/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Oct 01 2021 15:07:31 GMT+0200 (czas środkowoeuropejski letni)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.CONFIGURATION_SERVICE;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface Link {
  href: string;
  templated: boolean;
}

export interface MGCompanyList {
  mgid: number;
  mgname: string;
  mgreference: string;
}

export interface MGCompanyListResponse {
  mgid: number;
  mgname: string;
}

export interface MGCompanyResponse {
  currcode?: string;
  countcode: string;
  lancode: string;
  mgbankissuer: string;
  mgcapital: string;
  mgemail: string;
  mgfiscalcity: string;
  mgfiscalid: string;
  mgfree1: string;
  mgfree2: string;
  mgfree3: string;
  mgfree4: string;
  mgfree5: string;
  mgid: number;
  mglegalform: string;
  mgmainadrcity: string;
  mgmainadrcountry: string;
  mgmainadrregion: string;
  mgmainadrstreet1: string;
  mgmainadrstreet2: string;
  mgmainadrzipcode: string;
  mgmarketingname: string;
  mgname: string;
  mgreference: string;
  mgsignatoryname: string;
  mgsignatoryposition: string;
  mgsocialmedia: string;
  mgtaxid: string;
  mgtaxmode: string;
  mgtel1: string;
  mgtel2: string;
  mgwebsite: string;
}

export interface MgWithHoldingTax {
  whtid: number;
  mgid: number;
  sitype: string;
  siamountmin: number;
  siamountmax: number;
  whtevaluationmode: string;
  whtpercentage: number;
  whtfixedamount: number;
  siscategory: string;
  whtlabel: string;
}

export interface MGOfferParFilteringRequest {
  mgid: number;
  offerid: number;
  parcode: string;
  parvalue: string;
}

export interface MGParListRequest {
  mgid: number;
  parcode: string;
  parvalue: string;
}

export interface MGProductParFilteringRequest {
  mgid: number;
  parcode: string;
  parvalue: string;
  prcode: string;
}
export interface MgBUserProfile {
  brid: number;
  enddate: string;
  flagdefault: boolean;
  mgbuserprofileid: number;
  mgbusers: MgBUsers;
  mgid: number;
  profilecode: string;
  profiletype: string;
  startdate: string;
  userid: number;
}

export interface MgBUserProfileRequest {
  brid: number;
  mgbuserid: number;
  mgbuserprofileid: number;
  mgid: number;
  mguserid: number;
  profilecode: string;
  profiletype: string;
  userid: number;
  enddate?: string;
  flagdefault?: boolean;
  startdate?: string;
}

export interface MgBUserProfileResponse {
  enddate: string;
  flagdefault: boolean;
  mgbuserid: number;
  mgbuserprofileid: number;
  mgid: number;
  mguserid: number;
  profilecode: string;
  profiletype: string;
  profilelabel: string;
  startdate: string;
  userid: number;
  username?: string;
}

export interface MgBUserResponse {
  brid: number;
  email: string;
  mgbuserid: number;
  mgid: number;
  mguserid: number;
  name: string;
  surname: string;
  userid: number;
  username: string;
  usertype: string;
}

export interface MgBUsers {
  brid: number;
  enddate: string;
  flagdefault: boolean;
  mgBUserProfiles: Array<MgBUserProfile>;
  mgbuserid: number;
  mgid: number;
  mgusers: MgUsers;
  startdate: string;
  userid: number;
}

export interface MgBUsersRequest {
  brid: number;
  enddate?: string;
  flagdefault?: boolean;
  mgbuserid: number;
  mgid: number;
  mguserid: number;
  startdate?: string;
  userid: number;
}

export interface MgBankAccount {
  accdirection: string;
  accid: number;
  acclabel: string;
  bkaccountkey: string;
  bkaccountnum: string;
  bkbranchcode: string;
  bkcode?: string;
  bkenddate: string;
  bkstartdate: string;
  bkstatus: string;
  bkstatusdate: string;
  bktype: string;
  countcode: string;
  currcode: string;
  flagdefault: boolean;
  mgid: number;
  tpbankname: string;
  tpbic: string;
  tpcbdate: string;
  tpcbkey: string;
  tpcbname: string;
  tpcbnum: string;
  tpcbtype: string;
  tpiban: string;
}

export interface MgBranch {
  bremail: string;
  brenddate: string;
  brid: number;
  brmainadrcity: string;
  brmainadrcountry: string;
  brmainadrstreet1: string;
  brmainadrstreet2: string;
  brmainadrzipcode: string;
  brname: string;
  brstartdate: string;
  brtel1: string;
  brtel2: string;
  channelcode: string;
  mgid: number;
}

export interface MgBroker {
  associd: number;
  brokerstatus: string;
  enddate: string;
  mgid: number;
  networkcode: string;
  startdate: string;
  tpidbroker: number;
  tpname: string;
  tpreference: string;
  tprole: string;
}

export interface MgBrokerResponse {
  associd: number;
  brokername: string;
  brokerreference: string;
  brokerstatus: string;
  enddate: string;
  mgid: number;
  mgname: string;
  networkcode: string;
  networklabel: string;
  startdate: string;
  statuslabel: string;
  tpidbroker: number;
  tprole: string;
  tprolelabel: string;
}

export interface MgBrokerVendor {
  enddate: string;
  mgid: number;
  startdate: string;
  tpidbroker: number;
  userid: number;
  vendoremail: string;
  vendorid: number;
  vendormobile: string;
  vendorname: string;
  vendorstatus: string;
  vendorsurname: string;
  vendortel: string;
}

export interface MgBrokerVendorResponse {
  brokername: string;
  brokerreference: string;
  enddate: string;
  mgid: number;
  startdate: string;
  tpidbroker: number;
  userid: number;
  username: string;
  userusername: string;
  userusersurname: string;
  vendoremail: string;
  vendorid: number;
  vendormobile: string;
  vendorname: string;
  vendorstatus: string;
  vendorsurname: string;
  vendortel: string;
  vendorstatuslabel: string;
}

export interface MgTaxResponse {
  mgid: number;
  taxcode: string;
  taxlabel: string;
}

export interface MgUserProfile {
  enddate: string;
  flagdefault: boolean;
  mgid: number;
  mguserprofileid: number;
  mgusers: MgUsers;
  profilecode: string;
  profiletype: string;
  startdate: string;
  userid: number;
}

export interface MgUserProfileRequest {
  enddate: string;
  flagdefault: boolean;
  mgid: number;
  mguserid: number;
  mguserprofileid: number;
  profilecode: string;
  profiletype: string;
  startdate: string;
  userid: number;
}

export interface MgUserProfileResponse {
  enddate: string;
  flagdefault: boolean;
  mgid: number;
  mguserid: number;
  mguserprofileid: number;
  profilecode: string;
  profiletype: string;
  profilelabel: string;
  startdate: string;
  userid: number;
}

export interface MgUserResponse {
  email: string;
  mgid: number;
  mguserid: number;
  name: string;
  surname: string;
  userid: number;
  username: string;
  usertype: string;
}

export interface MgUsers {
  enddate: string;
  flagdefault: boolean;
  mgBUsers: Array<MgBUsers>;
  mgUserProfile: Array<MgUserProfile>;
  mgid: number;
  mguserid: number;
  startdate: string;
  users: Users;
}

export interface MgUsersParFiltering {
  filterid: number;
  flagdefault: boolean;
  mgid: number;
  parcode: string;
  parvalue: string;
  userid: number;
}

export interface MgUsersParFilteringResponse {
  filterid: number;
  flagdefault: boolean;
  mgid: number;
  mgname: string;
  parcode: string;
  parcodelabel: string;
  parvalue: string;
  parvaluelabel: string;
  userid: number;
}
export interface Parbank {
  bkbic: string;
  bkcode?: string;
  bkibanprefix?: string;
  bkname: string;
  countcode: string;
}

export interface MgUsersRequest {
  mgid: number;
  mguserid: number;
  userid: number;
  startdate?: string;
  useridmanager?: string;
}

export interface Mguserlanding {
  mgid: number;
  part1graph: string;
  part1height: number;
  part1kpi: string;
  part1label: string;
  part1type: string;
  part1view: string;
  part1width: number;
  part2graph: string;
  part2height: number;
  part2kpi: string;
  part2label: string;
  part2type: string;
  part2view: string;
  part2width: number;
  part3graph: string;
  part3height: number;
  part3kpi: string;
  part3label: string;
  part3type: string;
  part3view: string;
  part3width: number;
  partid: number;
  partorder: number;
  userid: number;
}

export interface MguserlandingResponse {
  mgid: number;
  mgname: string;
  part1graph: string;
  part1graphLabel: string;
  part1height: number;
  part1kpi: string;
  part1kpiLabel: string;
  part1label: string;
  part1type: string;
  part1typeLabel: string;
  part1view: string;
  part1viewLabel: string;
  part1width: number;
  part2graph: string;
  part2graphLabel: string;
  part2height: number;
  part2kpi: string;
  part2kpiLabel: string;
  part2label: string;
  part2type: string;
  part2typeLabel: string;
  part2view: string;
  part2viewLabel: string;
  part2width: number;
  part3graph: string;
  part3graphLabel: string;
  part3height: number;
  part3kpi: string;
  part3kpiLabel: string;
  part3label: string;
  part3type: string;
  part3typeLabel: string;
  part3view: string;
  part3viewLabel: string;
  part3width: number;
  partid: number;
  partorder: number;
  userid: number;
}

export interface ModelAndView {
  empty: boolean;
  model: {};
  modelMap: {};
  reference: boolean;
  status:
  | '100 CONTINUE'
  | '101 SWITCHING_PROTOCOLS'
  | '102 PROCESSING'
  | '103 CHECKPOINT'
  | '200 OK'
  | '201 CREATED'
  | '202 ACCEPTED'
  | '203 NON_AUTHORITATIVE_INFORMATION'
  | '204 NO_CONTENT'
  | '205 RESET_CONTENT'
  | '206 PARTIAL_CONTENT'
  | '207 MULTI_STATUS'
  | '208 ALREADY_REPORTED'
  | '226 IM_USED'
  | '300 MULTIPLE_CHOICES'
  | '301 MOVED_PERMANENTLY'
  | '302 FOUND'
  | '302 MOVED_TEMPORARILY'
  | '303 SEE_OTHER'
  | '304 NOT_MODIFIED'
  | '305 USE_PROXY'
  | '307 TEMPORARY_REDIRECT'
  | '308 PERMANENT_REDIRECT'
  | '400 BAD_REQUEST'
  | '401 UNAUTHORIZED'
  | '402 PAYMENT_REQUIRED'
  | '403 FORBIDDEN'
  | '404 NOT_FOUND'
  | '405 METHOD_NOT_ALLOWED'
  | '406 NOT_ACCEPTABLE'
  | '407 PROXY_AUTHENTICATION_REQUIRED'
  | '408 REQUEST_TIMEOUT'
  | '409 CONFLICT'
  | '410 GONE'
  | '411 LENGTH_REQUIRED'
  | '412 PRECONDITION_FAILED'
  | '413 PAYLOAD_TOO_LARGE'
  | '413 REQUEST_ENTITY_TOO_LARGE'
  | '414 URI_TOO_LONG'
  | '414 REQUEST_URI_TOO_LONG'
  | '415 UNSUPPORTED_MEDIA_TYPE'
  | '416 REQUESTED_RANGE_NOT_SATISFIABLE'
  | '417 EXPECTATION_FAILED'
  | '418 I_AM_A_TEAPOT'
  | '419 INSUFFICIENT_SPACE_ON_RESOURCE'
  | '420 METHOD_FAILURE'
  | '421 DESTINATION_LOCKED'
  | '422 UNPROCESSABLE_ENTITY'
  | '423 LOCKED'
  | '424 FAILED_DEPENDENCY'
  | '425 TOO_EARLY'
  | '426 UPGRADE_REQUIRED'
  | '428 PRECONDITION_REQUIRED'
  | '429 TOO_MANY_REQUESTS'
  | '431 REQUEST_HEADER_FIELDS_TOO_LARGE'
  | '451 UNAVAILABLE_FOR_LEGAL_REASONS'
  | '500 INTERNAL_SERVER_ERROR'
  | '501 NOT_IMPLEMENTED'
  | '502 BAD_GATEWAY'
  | '503 SERVICE_UNAVAILABLE'
  | '504 GATEWAY_TIMEOUT'
  | '505 HTTP_VERSION_NOT_SUPPORTED'
  | '506 VARIANT_ALSO_NEGOTIATES'
  | '507 INSUFFICIENT_STORAGE'
  | '508 LOOP_DETECTED'
  | '509 BANDWIDTH_LIMIT_EXCEEDED'
  | '510 NOT_EXTENDED'
  | '511 NETWORK_AUTHENTICATION_REQUIRED';
  view: View;
  viewName: string;
}

export interface ParCurrencyResponse {
  currcode: string;
  currlabel: string;
  currnbdecimal: number;
  currstatus: string;
  enddate: string;
  lancode: string;
  startdate: string;
}

export interface ParFunctionProfile {
  associd: number;
  flagdelete: boolean;
  flagget: boolean;
  flagpost: boolean;
  flagput: boolean;
  funcode: string;
  funmodule: string;
  profilecode: string;
}

export interface ParFunctionProfileResponse {
  associd: number;
  flagdelete: boolean;
  flagget: boolean;
  flagpost: boolean;
  flagput: boolean;
  funcode: string;
  funlabel: string;
  funmodule: string;
  profilecode: string;
  profilelabel: string;
}

export interface ParFunctionRequest {
  funcode: string;
  funid: number;
  funlabel: string;
  funmodule: string;
  funtype: string;
  serviceurl: string;
}

export interface ParFunctionResponse {
  funcode: string;
  funid: number;
  funlabel: string;
  funmodule: string;
  funtype: string;
  serviceurl: string;
}

export interface ParListRequest {
  parcode: string;
  parlistdescription: string;
  parlistlabel: string;
  parvalue: string;
  parvalueparent: string;
}

export interface ParListResponse {
  parflagdefault: boolean;
  parlistdescription: string;
  parlistlabel: string;
  parvalue: string;
  parvalueparent: string;
  parvalueparentlabel: string;
}

export interface ParMessage {
  lancode: string;
  module: string;
  msgid: number;
  msglabel: string;
  id: number;
}

export interface ParMessageResponse {
  lancode: string;
  module: string;
  modulelabel: string;
  msgid: number;
  msglabel: string;
  id: number;
}

export interface ParProductResponse {
  flagasset: boolean;
  flagmasterfacility: boolean;
  flagrealestate: boolean;
  flagspv: boolean;
  flagretailer: boolean;
  flagfleet: boolean;
  flaguseassetgrossamount: boolean;
  lancode: string;
  mgid: number;
  prcode: string;
  prlabel: string;
  mfprcode: string;
}

export interface ParRateResponse {
  parRateLists: Array<ParRateValue>;
  parratestatuslabel: string;
  parratetypelabel: string;
  ratecode: string;
  rateflow: string;
  rateflowlabel: string;
  ratelabel: string;
  ratestatus: string;
  ratetype: string;
  ratevalue: number;
  ceilingrate: number;
  ceilingdefaultrate: number;
  floorrate: number;
  floordefaultrate: number;
  calid: number;
  ratecategory:string
}

export interface ParRateValue {
  begindate: string;
  enddate: string;
  ratecode: string;
  ratevalue: number;
  ratevalueid: number;
}

export interface ParRateValueResponse {
  begindate: string;
  enddate: string;
  ratecode: string;
  ratevalue: number;
  ratevalueid: number;
}

export interface ParTaxRate {
  begindate: string;
  enddate: string;
  taxcode: string;
  taxrate: number;
  taxrateid: number;
}

export interface ParTaxRateResponse {
  begindate: string;
  enddate: string;
  taxcode: string;
  taxrate: number;
}

export interface ParTaxResponse {
  id: number;
  lancode: string;
  mgid: number;
  taxcode: string;
  taxflow: string;
  taxlabel: string;
  taxrate: number;
}

export interface ParTaxResponse2 {
  parTaxLists: Array<ParTaxRate>;
  partaxrate: number;
  partaxstatuslabel: string;
  partaxtypelabel: string;
  taxcode: string;
  taxflow: string;
  taxflowlabel: string;
  taxlabel: string;
  taxrate: number;
  taxstatus: string;
  taxtype: string;
}

export interface ParameterRequest {
  flagofferfilter: boolean;
  flagproductfilter: boolean;
  flagsystem: boolean;
  flaguserfilter: boolean;
  parcode: string;
  parcodeparent: string;
  pardescription: string;
  parlabel: string;
  parmodule: string;
  paroperator: string;
  partype: string;
  parvaluemax: string;
  parvaluemin: string;
}

export interface ParameterResponse {
  flagofferfilter: boolean;
  flagproductfilter: boolean;
  flagsystem: boolean;
  flaguserfilter: boolean;
  parLists: Array<ParListResponse>;
  parcode: string;
  parcodeparent: string;
  parcodeparentlabel: string;
  pardescription: string;
  parlabel: string;
  parmodule: string;
  parmodulelabel: string;
  paroperator: string;
  partype: string;
  partypelabel: string;
  parvaluemax: string;
  parvaluemin: string;
  parvalueexternal: string;
}

export interface ParametersLabel {
  lancode: string;
  parcode: string;
  pardescription: string;
  parlabel: string;
}

export interface ParametersListResponse {
  parcode: string;
  parcodeparent: string;
  parcodeparentlabel: string;
  pardescription: string;
  parlabel: string;
  parmodule: string;
  parmodulelabel: string;
  partype: string;
  partypelabel: string;
}

export interface Parcontrolconfig {
  ccid: number;
  ccode: string;
  flagblocking: boolean;
  mgid: number;
  objectstatus: string;
  offerid: number;
  prcode: string;
  tptype: string;
}

export interface PartranscodingResponse {
  associd: number;
  parcode: string;
  parcodelabel: string;
  parexternalvalue: string;
  parlabel: string;
  parvalue: string;
  parvaluelabel: string;
}

export interface ParvalueDefaultRequest {
  mgid: number;
  offerid: number;
  parcode: string;
  parvalue: string;
  prcode: string;
  target: string;
  userid: number;
}

export interface ParvalueRequest {
  mgid: number;
  offerid: number;
  parcode: string;
  parvaluemax: string;
  parvaluemin: string;
  prcode: string;
  target: string;
  userid: number;
}

export interface UserRequest {
  created_at: string;
  email: string;
  id: number;
  lancode: string;
  locked: boolean;
  mgUsersList: Array<MgUsers>;
  mgid: number;
  mobile: string;
  name: string;
  password: string;
  phone: string;
  route: string;
  status: string;
  surname: string;
  tabposition: string;
  updated_at: string;
  username: string;
  userrole: string;
  usertype: string;
}

export interface UserSessionParameters {
  lancode: string;
  mgid: number;
  route: string;
  tabposition: string;
}

export interface Users {
  changepassword: boolean;
  created_at: string;
  email: string;
  id: number;
  lancode: string;
  locked: boolean;
  mgUsersList: Array<MgUsers>;
  mgid: number;
  mobile: string;
  name: string;
  password: string;
  phone: string;
  route: string;
  status: string;
  surname: string;
  tabposition: string;
  updated_at: string;
  username: string;
  userrole: string;
  usertype: string;
  useridmanager?: string;
  themeid: number;
}

export interface View {
  contentType: string;
}

export interface ViewParControl {
  ccode: string;
  centity: string;
  clabel: string;
  cmessage: string;
  id: number;
  lancode: string;
}

export interface ViewParControlConfig {
  ccid: number;
  ccode: string;
  centity: string;
  clabel: string;
  cmessage: string;
  flagblocking: boolean;
  id: number;
  lancode: string;
  mgid: number;
  objectstatus: string;
  offerid: number;
  prcode: string;
  tptype: string;
}

export interface ViewParList {
  id: number;
  lancode: string;
  mgid: number;
  parcode: string;
  parflagdefault: boolean;
  parlistlabel: string;
  parmodule: string;
  parvalue: string;
  parvalueparent: string;
}

export interface ViewParListResponse {
  id: number;
  lancode: string;
  mgid: number;
  parcode: string;
  parflagdefault: boolean;
  parlistlabel: string;
  parmodule: string;
  parvalue: string;
  parvalueparent: string;
}

export interface ParaddressResponse {
  paradrid: number;
  zipcode: String;
  city: String;
  citylabel: String;
  region: String;
  regionlabel: String;
  regionglobal: String;
  regiongloballabel: String;
  country: String;
  countrylabel: String;
  mgid: number;
  lancode: String;
}
export interface ViewParValue {
  id: number;
  lancode: string;
  mgid: number;
  parcode: string;
  parlabel: string;
  parmodule: string;
  paroperator: string;
  parvaluemax: string;
  parvaluemin: string;
}

export interface ViewParValueOffer {
  id: number;
  lancode: string;
  mgid: number;
  offerid: number;
  offervaluemax: string;
  offervaluemin: string;
  parcode: string;
  parlabel: string;
  parmodule: string;
  paroperator: string;
  parvaluemax: string;
  parvaluemin: string;
}

export interface ViewParValueProduct {
  id: number;
  lancode: string;
  mgid: number;
  parcode: string;
  parlabel: string;
  parmodule: string;
  paroperator: string;
  parvaluemax: string;
  parvaluemin: string;
  prcode: string;
  productvaluemax: string;
  productvaluemin: string;
}

export interface ViewParValueSystem {
  id: number;
  lancode: string;
  parcode: string;
  parlabel: string;
  parmodule: string;
  paroperator: string;
  parvaluemax: string;
  parvaluemin: string;
}

export interface changePwdRequest {
  newpassword: string;
  oldpassword: string;
  username: string;
}

export interface ParRateFormulaByTypeResponse {
  flagcomplex: true;
  formulacode: string;
  formulalabel: string;
  formulastatus: string;
  formulastatuslabel: string;
  formulatype: string;
  formulatypelabel: string;
  ratecode: string;
  ratelabel: string;
  rateriskcost: number;
  ratespread: number;
  ratevalue: number;
  ceilingrate: number;
  ceilingdefaultrate: number;
  floorrate: number;
  floordefaultrate: number;
  calid: number;
  flagbonification:boolean
}
export interface Parrateformula {
  flagcomplex: boolean;
  formulacode: string;
  formulalabel?:string;
  formulastatus: string;
  formulatype: string;
  ratecode: string;
  ratelabel?:string;
  ratevalue?:number;
  rateriskcost: number;
  ratespread: number;
  ratecodespread:string,
  flagbonification:boolean
}


export interface MgBUserAndProfileResponse {
  brid: number;
  enddate: string;
  flagdefault: boolean;
  mgbuserProfileResponse: Array<MgBUserProfileResponse>;
  mgbuserid: number;
  mgid: number;
  mguserid: number;
  startdate: string;
  userid: number;
}

export interface ProductConfig {
  flagasset: boolean;
  flagmasterfacility: boolean;
  flagrealestate: boolean;
  flaguseassetgrossamount: boolean;

  flagretailer: boolean;
  flagfleet: boolean;

  id: number;
  lancode: string;
  mfprcode: string;
  prcode: string;
  prlabel: string;
}

export interface ParProductRequest {
  flagasset: boolean;
  flagmasterfacility: boolean;
  flagrealestate: boolean;
  flaguseassetgrossamount: boolean;
  flagspv: boolean;
  flagretailer: boolean;
  flagfleet: boolean;

  mfprcode: string;
  prcode: string;
  prlabel: string;
}

export interface ParProduct {
  flagasset: boolean;
  flagmasterfacility: boolean;
  flagrealestate: boolean;

  flagretailer: boolean;
  flagfleet: boolean;
  flaguseassetgrossamount: boolean;
  mfprcode: string;
  prcode: string;
}

export interface Mgproduct {
  enddate: string;
  mgid: number;
  prcode: string;
  startdate: string;
}
export interface MgBankAccountResponse {
  accdirection: string;
  accid: number;
  acclabel: string;
  bkaccountkey: string;
  bkaccountnum: string;
  bkbranchcode: string;
  bkbranchename: string;
  bkcode?: string;
  bkenddate: string;
  bkstartdate: string;
  bkstatus: string;
  bkstatusdate: string;
  bkstatuslabel: string;
  bktype: string;
  countcode: string;
  currcode: string;
  flagdefault: boolean;
  mgid: number;
  tpbankname: string;
  tpbic: string;
  tpcbdate: string;
  tpcbkey: string;
  tpcbname: string;
  tpcbnum: string;
  tpcbtype: string;
  tpiban: string;
}

export interface RemoveMgProductParams {
  mgid: number;
  prcode: string;
}

export interface GetParCurrencyByCurrcodeParams {
  currcode: string;
}

export interface CurrencyRateResponse {
  buyRate: number;
  currcode: string;
  currcodeTarget: string;
  endDate: string;
  id: number;
  sellRate: number;
  startDate: string;
}
export interface GetListCurrencyRateByCriteriaParams {
  buyRate: number;
  currcode: string;
  currcodeTarget: string;
  endDate: string;
  sellRate: number;
  startDate: string;
}

export interface ParcurrencyRate {
  buyRate: number;
  currcode: string;
  currcodeTarget: string;
  endDate: string;
  id: number;
  sellRate: number;
  startDate: string;
}
export interface MgWithHoldingTaxResponse {
  mgid: number;
  siamountmax: number;
  siamountmin: number;
  sitype: string;
  sitypelabel: string;
  whtevaluationmode: string;
  whtevaluationmodelabel: string;
  whtfixedamount: number;
  whtid: number;
  whtpercentage: number;
}

export interface Parkafka {
  description: string;
  entity: string;
  flagenabled: boolean;
  id: number;
  label: string;
  topic: string;
}
export interface Parentityfollowup {
  action: string;
  entity: string;
  flagfollow: boolean;
  flagkafka: boolean;
  id: number;
}
export interface GetparEntityFollowUpByCriteriaParams {
  action: string;
  entity: string;
  flagfollow: boolean;
  flagkafka: boolean;
  id: number;
}

export interface ViewParControlConfigResponse {
  ccid: number;
  ccode: string;
  centity: string;
  clabel: string;
  cmessage: string;
  flagblocking: boolean;
  id: number;
  lancode: string;
  mgid: number;
  mgname: string;
  objectstatus: string;
  objectstatuslabel: string;
  offerid: number;
  offerlabel: string;
  prcode: string;
  prcodelabel: string;
  tptype: string;
  tptypelabel: string;
}

export interface ParControlRequest {
  ccode: string;
  centity: string;
  clabel: string;
  cmessage: string;
  id: number;
  lancode: string;
}

export interface ParControlResponse {
  ccode: string;
  centity: string;
  clabel: string;
  cmessage: string;
  lancode: string;
}
export interface ProductConversionRuleResponse {
  rulid: number;
  sourcePrcode: string;
  sourcePrcodelabel?: string;
  targetPrcode: string;
  targetPrcodelabel?: string;
  isAuthorized: boolean;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
}
/**
 * @tags Par Entity Follow Up Controller
 * @summary getparEntityFollowUpByCriteria
 */
export function getparEntityFollowUpByCriteria(
  params: GetparEntityFollowUpByCriteriaParams
) {
  return request.get<AbstractResponse<object, Parentityfollowup>>(
    `${URL}/api/parentityfollowup` +
    prepareQueryParams({
      action: params.action,
      entity: params.entity,
      flagfollow: params.flagfollow,
      flagkafka: params.flagkafka,
      id: params.id,
    } as any)
  );
}

export interface AddparentityfollowupParams {
  req: Parentityfollowup;
}

/**
 * @tags Par Entity Follow Up Controller
 * @summary addparentityfollowup
 */
export function addparentityfollowup(params: AddparentityfollowupParams) {
  return request.post<AbstractResponse<Parentityfollowup, object>>(
    `${URL}/api/parentityfollowup`,
    params.req
  );
}

export interface GetparentityfollowupByIdParams {
  id: number;
}

/**
 * @tags Par Entity Follow Up Controller
 * @summary getparentityfollowupById
 */
export function getparentityfollowupById(
  params: GetparentityfollowupByIdParams
) {
  return request.get<AbstractResponse<Parentityfollowup, object>>(
    `${URL}/api/parentityfollowup/${params.id}`
  );
}

export interface UpdateparentityfollowupParams {
  id: number;
  req: Parentityfollowup;
}

/**
 * @tags Par Entity Follow Up Controller
 * @summary updateparentityfollowup
 */
export function updateparentityfollowup(params: UpdateparentityfollowupParams) {
  return request.put<AbstractResponse<Parentityfollowup, object>>(
    `${URL}/api/parentityfollowup/${params.id}`,
    params.req
  );
}

export interface DeleteparentityfollowupParams {
  id: number;
}

/**
 * @tags Par Entity Follow Up Controller
 * @summary deleteparentityfollowup
 */
export function deleteparentityfollowup(params: DeleteparentityfollowupParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parentityfollowup/${params.id}`
  );
}
export interface GetParkafkaByCriteriaParams {
  entity: string;
  flagenabled: boolean;
  id: number;
  topic: string;
}

/**
 * @tags Parkafka Controller
 * @summary getParkafkaByCriteria
 */
export function getParkafkaByCriteria(params: GetParkafkaByCriteriaParams) {
  return request.get<AbstractResponse<object, Parkafka>>(
    `${URL}/api/parkafka` +
    prepareQueryParams({
      entity: params.entity,
      flagenabled: params.flagenabled,
      id: params.id,
      topic: params.topic,
    } as any)
  );
}

export interface AddParkafkaParams {
  req: Parkafka;
}

/**
 * @tags Parkafka Controller
 * @summary addParkafka
 */
export function addParkafka(params: AddParkafkaParams) {
  return request.post<AbstractResponse<object, Parkafka>>(
    `${URL}/api/parkafka`,
    params.req
  );
}

export interface GetParkafkaByIdParams {
  id: number;
}

/**
 * @tags Parkafka Controller
 * @summary getParkafkaById
 */
export function getParkafkaById(params: GetParkafkaByIdParams) {
  return request.get<AbstractResponse<Parkafka, object>>(
    `${URL}/api/parkafka/${params.id}`
  );
}

export interface UpdateParkafkaParams {
  id: number;
  req: Parkafka;
}

/**
 * @tags Parkafka Controller
 * @summary updateParkafka
 */
export function updateParkafka(params: UpdateParkafkaParams) {
  return request.put<AbstractResponse<object, Parkafka>>(
    `${URL}/api/parkafka/${params.id}`,
    params.req
  );
}

export interface DeleteParkafkaParams {
  id: number;
}

/**
 * @tags Parkafka Controller
 * @summary deleteParkafka
 */
export function deleteParkafka(params: DeleteParkafkaParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parkafka/${params.id}`
  );
}

export interface UpdateCurrencyRateParams {
  id: number;
  req: ParcurrencyRate;
}

/**
 * @tags Par Currency Controller
 * @summary updateCurrencyRate
 */
export function updateCurrencyRate(params: UpdateCurrencyRateParams) {
  return request.put<AbstractResponse<ParcurrencyRate, object>>(
    `${URL}/api/parcurrency/currencyrate/${params.id}`,
    params.req
  );
}

export interface DeleteCurrencyRateParams {
  id: number;
}

/**
 * @tags Par Currency Controller
 * @summary deleteCurrencyRate
 */
export function deleteCurrencyRate(params: DeleteCurrencyRateParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parcurrency/currencyrate/${params.id}`
  );
}

export interface AddCurrencyRateParams {
  req: ParcurrencyRate;
}

/**
 * @tags Par Currency Controller
 * @summary addCurrencyRate
 */
export function addCurrencyRate(params: AddCurrencyRateParams) {
  return request.post<AbstractResponse<ParcurrencyRate, object>>(
    `${URL}/api/parcurrency/currencyrate`,
    params.req
  );
}

export interface UpdateParCurrencyStatusParams {
  currcode: string;
  status: string;
}

export interface GetMgWithHoldingTaxConfigListParams {
  mgid: number;
  sitype: string;
}
export interface AddMgWithHoldingTaxConfigParams {
  request: MgWithHoldingTax;
}
export interface MgciladditionaltaxResponse {
  ciamountmax: number;
  ciamountmin: number;
  cilcategorytarget: string;
  cilcategorytargetlabel: string;
  cildescription: string;
  ciltypetarget: string;
  ciltypetargetlabel: string;
  citype: string;
  citypelabel: string;
  mgid: number;
  taxcode: string;
  taxevalulationmode: string;
  taxevalulationmodelabel: string;
  taxfixedamount: number;
  taxid: number;
  taxpercentage: number;
}

export interface Mgciladditionaltax {
  ciamountmax: number;
  ciamountmin: number;
  cilcategorytarget: string;
  cildescription: string;
  ciltypetarget: string;
  citype: string;
  mgid: number;
  taxcode: string;
  taxevalulationmode: string;
  taxfixedamount: number;
  taxid: number;
  taxpercentage: number;
}

export interface GetMgciladditionaltaxConfigListParams {
  citype: string;
  mgid: number;
}

export function addMgWithHoldingTaxConfig(
  params: AddMgWithHoldingTaxConfigParams
) {
  return request.post<AbstractResponse<MgWithHoldingTaxResponse, object>>(
    `${URL}/api/mgwhtax`,
    params.request
  );
}
/**
 * @tags Mg Controller
 * @summary getMgWithHoldingTaxConfigList
 */
export function getMgWithHoldingTaxConfigList(
  params: GetMgWithHoldingTaxConfigListParams
) {
  return request.get<AbstractResponse<object, MgWithHoldingTaxResponse>>(
    `${URL}/api/mgwhtax/${params.mgid}/${params.sitype}`
  );
}
export interface UpdateMgWithHoldingTaxConfigParams {
  request: MgWithHoldingTax;
  whtid: number;
}

/**
 * @tags Mg Controller
 * @summary updateMgWithHoldingTaxConfig
 */
export function updateMgWithHoldingTaxConfig(
  params: UpdateMgWithHoldingTaxConfigParams
) {
  return request.put<AbstractResponse<MgWithHoldingTaxResponse, object>>(
    `${URL}/api/mgwhtax/${params.whtid}`,
    params.request
  );
}

export interface DeleteMgWithHoldingTaxConfigParams {
  whtid: number;
}

/**
 * @tags Mg Controller
 * @summary deleteMgWithHoldingTaxConfig
 */
export function deleteMgWithHoldingTaxConfig(
  params: DeleteMgWithHoldingTaxConfigParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/mgwhtax/${params.whtid}`
  );
}

/**
 * @tags Mg Controller
 * @summary getMgciladditionaltaxConfigList
 */
export function getMgciladditionaltaxConfigList(
  params: GetMgciladditionaltaxConfigListParams
) {
  return request.get<AbstractResponse<object, MgciladditionaltaxResponse>>(
    `${URL}/api/mgciladditionaltax/${params.mgid}/${params.citype}`
  );
}

export interface UpdateMgciladditionaltaxConfigParams {
  request: Mgciladditionaltax;
  taxid: number;
}

/**
 * @tags Mg Controller
 * @summary updateMgciladditionaltaxConfig
 */
export function updateMgciladditionaltaxConfig(
  params: UpdateMgciladditionaltaxConfigParams
) {
  return request.put<AbstractResponse<MgciladditionaltaxResponse, object>>(
    `${URL}/api/mgciladditionaltax/${params.taxid}`,
    params.request
  );
}

export interface RemoveMgciladditionaltaxConfigParams {
  taxid: number;
}

/**
 * @tags Mg Controller
 * @summary removeMgciladditionaltaxConfig
 */
export function removeMgciladditionaltaxConfig(
  params: RemoveMgciladditionaltaxConfigParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/mgciladditionaltax/${params.taxid}`
  );
}

/**
 * @tags Par Currency Controller
 * @summary updateParCurrencyStatus
 */
export function updateParCurrencyStatus(params: UpdateParCurrencyStatusParams) {
  return request.put<AbstractResponse<ParCurrencyResponse, object>>(
    `${URL}/api/parcurrency/${params.currcode}/${params.status}`
  );
}
export interface AddMgciladditionaltaxConfigParams {
  request: Mgciladditionaltax;
}

/**
 * @tags Mg Controller
 * @summary addMgciladditionaltaxConfig
 */
export function addMgciladditionaltaxConfig(
  params: AddMgciladditionaltaxConfigParams
) {
  return request.post<AbstractResponse<MgciladditionaltaxResponse, object>>(
    `${URL}/api/mgciladditionaltax`,
    params.request
  );
}

/**
 * @tags Par Currency Controller
 * @summary getListCurrencyRateByCriteria
 */
export function getListCurrencyRateByCriteria(
  params: GetListCurrencyRateByCriteriaParams
) {
  return request.get<AbstractResponse<object, CurrencyRateResponse>>(
    `${URL}/api/parcurrency/currencyrate` +
    prepareQueryParams({
      buyRate: params.buyRate,
      currcode: params.currcode,
      currcodeTarget: params.currcodeTarget,
      endDate: params.endDate,
      sellRate: params.sellRate,
      startDate: params.startDate,
    } as any)
  );
}

/**
 * @tags Par Currency Controller
 * @summary getParCurrencyByCurrcode
 */
export function getParCurrencyByCurrcode(
  params: GetParCurrencyByCurrcodeParams
) {
  return request.get<AbstractResponse<ParCurrencyResponse, object>>(
    `${URL}/api/parcurrency/${params.currcode}`
  );
}

/**
 * @tags Parameters Controller
 * @summary removeMgProduct
 */
export function removeMgProduct(params: RemoveMgProductParams) {
  return request.delete<AbstractResponse<Mgproduct, object>>(
    `${URL}/api/mgproduct/${params.mgid}/${params.prcode}`
  );
}

export interface GetMgByPrcodeParams {
  prcode: string;
}

export interface GetMgWithHoldingTaxListParams {
  sitype: string;
}

export interface GetMgParValueByParCodeParams {
  parcode: string;
}

export function getMgParValueByParCode(params: GetMgParValueByParCodeParams) {
  return request.get<AbstractResponse<ViewParValue, object>>(
    `${URL}/api/mgparvalue/${params.parcode}`
  );
}

export function getMgWithHoldingTaxList(params: GetMgWithHoldingTaxListParams) {
  return request.get<AbstractResponse<object, MgWithHoldingTax>>(
    `${URL}/api/mgwhtax/${params.sitype}`
  );
}

/**
 * @tags Parameters Controller
 * @summary getMgByPrcode
 */
export function getMgByPrcode(params: GetMgByPrcodeParams) {
  return request.get<AbstractResponse<object, MGCompanyList>>(
    `${URL}/api/mgproduct/${params.prcode}`
  );
}

export interface AddMgProductParams {
  mgProductrequest: Mgproduct;
}

/**
 * @tags Parameters Controller
 * @summary addMgProduct
 */
export function addMgProduct(params: AddMgProductParams) {
  return request.post<AbstractResponse<Mgproduct, object>>(
    `${URL}/api/mgproduct`,
    params.mgProductrequest
  );
}

export interface UpdateProductParams {
  parProductrequest: ParProductRequest;
}

/**
 * @tags Parameters Controller
 * @summary updateProduct
 */
export function updateProduct(params: UpdateProductParams) {
  return request.put<AbstractResponse<ParProduct, object>>(
    `${URL}/api/parproduct`,
    params.parProductrequest
  );
}

export interface GetProductConfigByPrcodeParams {
  prcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getProductConfigById
 */
export function getProductConfigByPrcode(
  params: GetProductConfigByPrcodeParams
) {
  return request.get<AbstractResponse<ProductConfig, object>>(
    `${URL}/api/productConfiglist/${params.prcode}`
  );
}

export interface AddProductParams {
  parProductrequest: ParProductRequest;
}

/**
 * @tags Parameters Controller
 * @summary addProduct
 */
export function addProduct(params: AddProductParams) {
  return request.post<AbstractResponse<ParProduct, object>>(
    `${URL}/api/parproduct`,
    params.parProductrequest
  );
}

/**
 * @tags Parameters Controller
 * @summary getProductConfigList
 */
/*export function getProductConfigList() {
  return request.get<AbstractResponse<object, ProductConfig>>(
    `${URL}/api/productConfiglist`
  );
}*/

export function getProductConfigList(params: { prcode?: string; financedcategory?: string }) {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v != null && v !== '')
  );
  const query = new URLSearchParams(filteredParams).toString();
  return request.get<AbstractResponse<object, ProductConfig>>(
    `${URL}/api/productConfiglist?${query}`
  );
}


export interface MgBUserIdList {
  mgbuserid: number;
}

export interface RemoveMgBUserProfileParams {
  mgbuseridList: Array<MgBUserIdList>;
}

/**
 * @tags Users Controller
 * @summary removeMgBUserProfile
 */
export function removeMgBUserProfile(params: RemoveMgBUserProfileParams) {
  return request.delete<AbstractResponse<MgBUserProfile, object>>(
    `${URL}/api/users/mgbuserProfile`,
    params.mgbuseridList
  );
}

export interface GetMgBUserListParams {
  mgid: number;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary getMgBUserList
 */
export function getMgBUserList(params: GetMgBUserListParams) {
  return request.get<AbstractResponse<MgBUsers, object>>(
    `${URL}/api/users/MgBList/${params.mgid}/${params.userid}`
  );
}
export interface AddMgBUserProfileParams {
  mgBUserProfileRequestList: Array<MgBUserProfileRequest>;
}

/**
 * @tags Users Controller
 * @summary addMgBUserProfile
 */
export function addMgBUserProfile(params: AddMgBUserProfileParams) {
  return request.post<AbstractResponse<MgBUserProfile, object>>(
    `${URL}/api/users/mgbuserProfile`,
    params.mgBUserProfileRequestList
  );
}

export interface RemoveMgBUserParams {
  mgbuseridList: Array<MgBUserIdList>;
}

/**
 * @tags Users Controller
 * @summary removeMgBUser
 */
export function removeMgBUser(params: RemoveMgBUserParams) {
  return request.delete<AbstractResponse<MgBUsers, object>>(
    `${URL}/api/users/mgbuser`,
    params.mgbuseridList
  );
}

export interface AddMgBUserParams {
  mgBUsersRequestList: Array<MgBUsersRequest>;
}

/**
 * @tags Users Controller
 * @summary addMgBUser
 */
export function addMgBUser(params: AddMgBUserParams) {
  return request.post<AbstractResponse<MgBUsers, object>>(
    `${URL}/api/users/mgbuser`,
    params.mgBUsersRequestList
  );
}


export interface MguserProfileIdList {
  mguserprofileid: number;
}

export interface RemoveMguserProfileParams {
  mguserProfileIdList: Array<MguserProfileIdList>;
}

/**
 * @tags Users Controller
 * @summary removeMguserProfile
 */
export function removeMguserProfile(params: RemoveMguserProfileParams) {
  return request.delete<AbstractResponse<MgUserProfile, object>>(
    `${URL}/api/users/mguserProfile`,
    params.mguserProfileIdList
  );
}

export interface GetMgBUserAndProfileParams {
  brid: number;
  flag: boolean;
  mgid: number;
  userid: number;
}

export interface AddMguserProfileParams {
  mgUserProfileRequestList: Array<MgUserProfileRequest>;
}

/**
 * @tags Users Controller
 * @summary addMguserProfile
 */
export function addMguserProfile(params: AddMguserProfileParams) {
  return request.post<AbstractResponse<MgUserProfile, object>>(
    `${URL}/api/users/mguserProfile`,
    params.mgUserProfileRequestList
  );
}

/**
 * @tags Users Controller
 * @summary getMgBUserAndProfile
 */
export function getMgBUserAndProfile(params: GetMgBUserAndProfileParams) {
  return request.get<AbstractResponse<object, MgBUserAndProfileResponse>>(
    `${URL}/api/users/MgBList/${params.mgid}/${params.userid}/${params.brid}` +
    prepareQueryParams({ flag: params.flag } as any)
  );
}

export interface GetMgUserAndProfileParams {
  flag: boolean;
  mgid: number;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary getMgUserAndProfile
 */
export function getMgUserAndProfile(params: GetMgUserAndProfileParams) {
  return request.get<AbstractResponse<object, MgUserAndProfilesResponse>>(
    `${URL}/api/users/MgList/${params.mgid}/${params.userid}` +
    prepareQueryParams({ flag: params.flag } as any)
  );
}

export interface MgUserAndProfilesResponse {
  enddate: string;
  flagdefault: boolean;
  mgUserProfileResponse: Array<MgUserProfileResponse>;
  mgid: number;
  mguserid: number;
  startdate: string;
  userid: number;
  useridmanager: number;
}

export interface AddMgUserParams {
  mgUsersRequestList: Array<MgUsersRequest>;
}

/**
 * @tags Users Controller
 * @summary addMgUser
 */
export function addMgUser(params: AddMgUserParams) {
  return request.post<AbstractResponse<MgUsers, object>>(
    `${URL}/api/users/mguser`,
    params.mgUsersRequestList
  );
}

export interface MgUserIdList {
  mgid: number;
  userid: number;
}

export interface RemoveMgUserParams {
  mguseridlist: Array<MgUserIdList>;
}

/**
 * @tags Users Controller
 * @summary removeMgUser
 */
export function removeMgUser(params: RemoveMgUserParams) {
  return request.delete<AbstractResponse<MgUsers, object>>(
    `${URL}/api/users/mguser`,
    params.mguseridlist
  );
}

/**
 * @tags Web Mvc Links Handler
 * @summary links
 */
export function links() {
  return request.get<{}>(`${URL}/actuator`);
}

export interface HandleParams {
  body?: {};
}
/**
 * @tags Mg Controller
 * @summary getBuildingInfo
 */
export function getBuildingInfo() {
  return request.get<string>(`${URL}/api/Config/version`);
}

export interface GettaxrateParams {
  idate: string;
  taxcode: string;
}

/**
 * @tags Par Tax Controller
 * @summary gettaxrate
 */
export function gettaxrate(params: GettaxrateParams) {
  return request.get<number>(
    `${URL}/api/taxrate` +
    prepareQueryParams({
      taxcode: params.taxcode,
      idate: params.idate,
    } as any)
  );
}

export interface getParRateFormulaByTypeParams {
  formulatype: string;
}

/**
 * @tags FormulaRate Controller
 * @summary getParRateFormulaByType
 */
export function getParRateFormulaByType(params: getParRateFormulaByTypeParams) {
  return request.get<AbstractResponse<object, ParRateFormulaByTypeResponse>>(
    `${URL}/api/parrateformula/bytype/${params.formulatype}`
  );
}

export interface GetParRateFormulaListbyCriteriaParams {
  formulacode: string;
  formulalabel: string;
  formulastatus: string;
  formulatype: string;
  ratecode: string;
  ratelabel: string;
  ratecodespread?:number
  formuladescription?:string
}

export interface GetParRateFormulaListByIdParams {
  id: number;
}
/**
 * @tags Par Rate Formula Controller
 * @summary getParRateFormulaListById
 */
export function getParRateFormulaListById(
  params: GetParRateFormulaListByIdParams
) {
  return request.get<AbstractResponse<object, ParRateFormulaResponse>>(
    `${URL}/api/parrateformula/${params.id}`
  );
}
/**
 * @tags Par Rate Formula Controller
 * @summary getParRateFormulaListbyCriteria
 */
export function getParRateFormulaListbyCriteria(
  params: GetParRateFormulaListbyCriteriaParams
) {
  return request.get<AbstractResponse<object, ParRateFormulaResponse>>(
    `${URL}/api/parrateformula` +
    prepareQueryParams({
      formulacode: params.formulacode,
      formulalabel: params.formulalabel,
      formulastatus: params.formulastatus,
      formulatype: params.formulatype,
      ratecode: params.ratecode,
      ratelabel: params.ratelabel,
      ratecodespread:params.ratecodespread,
      formuladescription:params.formuladescription
    } as any)
  );
}
export interface AddParRateFormulaParams {
  parRateFormulaRequest: Parrateformula;
}
/**
 * @tags Par Rate Formula Controller
 * @summary addParRateFormula
 */
export function addParRateFormula(params: AddParRateFormulaParams) {
  return request.post<AbstractResponse< ParRateFormulaResponse,object>>(
    `${URL}/api/parrateformula`,
    params.parRateFormulaRequest
  );
}
export interface UpdateParRateFormulaParams {
  formulacode: string;
  parRateFormulaRequest: Parrateformula;
}
/**
 * @tags Par Rate Formula Controller
 * @summary updateParRateFormula
 */
export function updateParRateFormula(params: UpdateParRateFormulaParams) {
  return request.put<AbstractResponse<object, ParRateFormulaResponse>>(
    `${URL}/api/parrateformula/${params.formulacode}`,
    params.parRateFormulaRequest
  );
}
export interface DeleteParRateFormulaParams {
  formulacode: string;
}
/**
 * @tags Par Rate Formula Controller
 * @summary deleteParRateFormula
 */
export function deleteParRateFormula(params: DeleteParRateFormulaParams) {
  return request.delete<AbstractResponse<object, ParRateFormulaResponse>>(
    `${URL}/api/parrateformula/${params.formulacode}`
  );
}
export interface UpdateParRateFormulaStatusParams {
  formulacode: string;
  formulastatus: string;
}

/**
 * @tags Par Rate Formula Controller
 * @summary updateParRateFormulaStatus
 */
export function updateParRateFormulaStatus(
  params: UpdateParRateFormulaStatusParams
) {
  return request.put<AbstractResponse<object, ParRateFormulaResponse>>(
    `${URL}/api/parrateformula/${params.formulacode}/${params.formulastatus}`
  );
}

export interface GetFunctionsByCriteriaParams {
  funcode: string;
  funlabel: string;
  funmodule: string;
  funtype: string;
  serviceurl: string;
}

/**
 * @tags Parameters Controller
 * @summary getFunctionsByCriteria
 */
export function getFunctionsByCriteria(params: GetFunctionsByCriteriaParams) {
  return request.get<AbstractResponse<object, ParFunctionResponse>>(
    `${URL}/api/functions` +
    prepareQueryParams({
      funcode: params.funcode,
      funlabel: params.funlabel,
      funmodule: params.funmodule,
      funtype: params.funtype,
      serviceurl: params.serviceurl,
    } as any)
  );
}

export interface CreateFunctionParams {
  request: ParFunctionRequest;
}

/**
 * @tags Parameters Controller
 * @summary createFunction
 */
export function createFunction(params: CreateFunctionParams) {
  return request.post<AbstractResponse<ParFunctionResponse, object>>(
    `${URL}/api/functions`,
    params.request
  );
}

export interface GetFunctionsProfileByCriteriaParams {
  funcode: string;
  funlabel: string;
  funmodule: string;
  profilecode: string;
}

/**
 * @tags Parameters Controller
 * @summary getFunctionsProfileByCriteria
 */
export function getFunctionsProfileByCriteria(
  params: GetFunctionsProfileByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParFunctionProfileResponse>>(
    `${URL}/api/functions/profile` +
    prepareQueryParams({
      funcode: params.funcode,
      funlabel: params.funlabel,
      funmodule: params.funmodule,
      profilecode: params.profilecode,
    } as any)
  );
}

export interface CreateFunctionProfileParams {
  request: ParFunctionProfile;
}

/**
 * @tags Parameters Controller
 * @summary createFunctionProfile
 */
export function createFunctionProfile(params: CreateFunctionProfileParams) {
  return request.post<AbstractResponse<ParFunctionProfileResponse, object>>(
    `${URL}/api/functions/profile`,
    params.request
  );
}

export interface UpdateFunctionProfileParams {
  associd: number;
  request: ParFunctionProfile;
}

/**
 * @tags Parameters Controller
 * @summary updateFunctionProfile
 */
export function updateFunctionProfile(params: UpdateFunctionProfileParams) {
  return request.put<AbstractResponse<ParFunctionProfileResponse, object>>(
    `${URL}/api/functions/profile/${params.associd}`,
    params.request
  );
}

export interface DeleteFunctionProfileParams {
  associd: number;
}

/**
 * @tags Parameters Controller
 * @summary deleteFunctionProfile
 */
export function deleteFunctionProfile(params: DeleteFunctionProfileParams) {
  return request.delete<AbstractResponse<ParFunctionProfileResponse, object>>(
    `${URL}/api/functions/profile/${params.associd}`
  );
}

export interface UpdateFunctionParams {
  funid: number;
  request: ParFunctionRequest;
}

/**
 * @tags Parameters Controller
 * @summary updateFunction
 */
export function updateFunction(params: UpdateFunctionParams) {
  return request.put<AbstractResponse<ParFunctionResponse, object>>(
    `${URL}/api/functions/${params.funid}`,
    params.request
  );
}

export interface GetMGCompanyDetailParams {
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary getMGCompanyDetail
 */
export function getMGCompanyDetail(params: GetMGCompanyDetailParams) {
  return request.get<AbstractResponse<MGCompanyResponse, object>>(
    `${URL}/api/mgcompany/${params.mgid}`
  );
}

export interface GetBankAccountListByDirectionParams {
  currcode: string;
  direction: any;
  mgid: number;
  strict: boolean;
}

/**
 * @tags Mg Controller
 * @summary getBankAccountListByDirection
 */
export function getBankAccountListByDirection(
  params: GetBankAccountListByDirectionParams
) {
  return request.get<AbstractResponse<object, MgBankAccountResponse>>(
    `${URL}/api/mgcompany/accounts` +
    prepareQueryParams({
      currcode: params.currcode,
      direction: params.direction,
      mgid: params.mgid,
      strict: params.strict,
    } as any)
  );
}

export interface GetBranchListByMgidParams {
  mgid: number;
  brname: string;
  channelcode: string;
}

/**
 * @tags Mg Controller
 * @summary getBranchListByMgid
 */
export function getBranchListByMgid(params: GetBranchListByMgidParams) {
  return request.get<AbstractResponse<object, MgBranch>>(
    `${URL}/api/mgcompany/${params.mgid}/branch?brname=${params.brname}&channelcode=${params.channelcode}`
  );
}

export interface CreateBranchParams {
  branchRequest: MgBranch;
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary createBranch
 */
export function createBranch(params: CreateBranchParams) {
  return request.post<AbstractResponse<MgBranch, object>>(
    `${URL}/api/mgcompany/${params.mgid}/branch`,
    params.branchRequest
  );
}

export interface GetBranchByIDParams {
  brid: number;
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary getBranchByID
 */
export function getBranchByID(params: GetBranchByIDParams) {
  return request.get<AbstractResponse<MgBranch, object>>(
    `${URL}/api/mgcompany/${params.mgid}/branch/${params.brid}`
  );
}

export interface UpdateBranchParams {
  branchRequest: MgBranch;
  brid: number;
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary updateBranch
 */
export function updateBranch(params: UpdateBranchParams) {
  return request.put<AbstractResponse<MgBranch, object>>(
    `${URL}/api/mgcompany/${params.mgid}/branch/${params.brid}`,
    params.branchRequest
  );
}

export interface GetUserBranchListByMgidParams {
  brid: number;
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary getUserBranchListByMgid
 */
export function getUserBranchListByMgid(params: GetUserBranchListByMgidParams) {
  return request.get<AbstractResponse<object, MgBUserResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/branch/${params.brid}/users`
  );
}

export interface AddUserToBranchParams {
  brid: number;
  mgid: number;
  request: MgBUsersRequest;
}

/**
 * @tags Mg Controller
 * @summary addUserToBranch
 */
export function addUserToBranch(params: AddUserToBranchParams) {
  return request.post<AbstractResponse<object, MgBUserResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/branch/${params.brid}/users`,
    params.request
  );
}

export interface RemoveUserFromBranchParams {
  brid: number;
  mgid: number;
  request: MgBUsersRequest;
}

/**
 * @tags Mg Controller
 * @summary removeUserFromBranch
 */
export function removeUserFromBranch(params: RemoveUserFromBranchParams) {
  return request.delete<AbstractResponse<object, MgBUserResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/branch/${params.brid}/users`,
    params.request
  );
}

export interface GetUserProfileListByBranchParams {
  brid: number;
  mgid: number;
  userid: number;
}

/**
 * @tags Mg Controller
 * @summary getUserProfileListByBranch
 */
export function getUserProfileListByBranch(
  params: GetUserProfileListByBranchParams
) {
  return request.get<AbstractResponse<object, MgBUserProfileResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/branch/${params.brid}/users/${params.userid}/profile`
  );
}

export interface AddUserProfileToBranchParams {
  brid: number;
  mgid: number;
  request: MgBUserProfileRequest;
  userid: number;
}

/**
 * @tags Mg Controller
 * @summary addUserProfileToBranch
 */
export function addUserProfileToBranch(params: AddUserProfileToBranchParams) {
  return request.post<AbstractResponse<object, MgBUserProfileResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/branch/${params.brid}/users/${params.userid}/profile`,
    params.request
  );
}

export interface RemoveUserProfileFromBranchParams {
  brid: number;
  mgid: number;
  request: MgBUserProfileRequest;
  userid: number;
}

/**
 * @tags Mg Controller
 * @summary removeUserProfileFromBranch
 */
export function removeUserProfileFromBranch(
  params: RemoveUserProfileFromBranchParams
) {
  return request.delete<AbstractResponse<object, MgBUserProfileResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/branch/${params.brid}/users/${params.userid}/profile`,
    params.request
  );
}

export interface GetBrokerListByMgidParams {
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary getBrokerListByMgid
 */
export function getBrokerListByMgid(params: GetBrokerListByMgidParams) {
  return request.get<AbstractResponse<object, MgBrokerResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/broker`
  );
}

export interface CreateBrokerParams {
  brokerRequest: MgBroker;
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary createBroker
 */
export function createBroker(params: CreateBrokerParams) {
  return request.post<AbstractResponse<MgBrokerResponse, object>>(
    `${URL}/api/mgcompany/${params.mgid}/broker`,
    params.brokerRequest
  );
}
export interface GetBrokerListByCriteriaParams {
  mgid: number;
  brokername: string;
  networkcode: string;
  brokerreference: string;
  brokerstatus: string;
  tprole: string;
}

/**
 * @tags Mg Controller
 * @summary getBrokerListByCriteria
 */
export function getBrokerListByCriteria(params: GetBrokerListByCriteriaParams) {
  return request.get<AbstractResponse<object, MgBrokerResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/broker/search` +
    prepareQueryParams({
      mgid: params.mgid,
      brokername: params.brokername,
      networkcode: params.networkcode,
      brokerreference: params.brokerreference,
      brokerstatus: params.brokerstatus,
      tprole: params.tprole,
    } as any)
  );
}

export interface GetBrokerByAssocIDParams {
  associd: number;
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary getBrokerByAssocID
 */
export function getBrokerByAssocID(params: GetBrokerByAssocIDParams) {
  return request.get<AbstractResponse<MgBrokerResponse, object>>(
    `${URL}/api/mgcompany/${params.mgid}/broker/${params.associd}`
  );
}

export function getMyBrokerProfile(params: GetBrokerByAssocIDParams) {
  return request.get<AbstractResponse<MgBrokerResponse, object>>(
    `${URL}/api/mgcompany/${params.mgid}/myBrokerProfile`
  );
}

export interface UpdateBrokerParams {
  associd: number;
  brokerRequest: MgBroker;
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary updateBroker
 */
export function updateBroker(params: UpdateBrokerParams) {
  return request.put<AbstractResponse<MgBrokerResponse, object>>(
    `${URL}/api/mgcompany/${params.mgid}/broker/${params.associd}`,
    params.brokerRequest
  );
}

export interface UpdateBrokerStatusParams {
  associd: number;
  mgid: number;
  status: string;
}

/**
 * @tags Mg Controller
 * @summary updateBrokerStatus
 */
export function updateBrokerStatus(params: UpdateBrokerStatusParams) {
  return request.put<AbstractResponse<MgBrokerResponse, object>>(
    `${URL}/api/mgcompany/${params.mgid}/broker/${params.associd}/${params.status}`
  );
}

export interface GetVendorListByBrokeridParams {
  mgid: number;
  tpidbroker: number;
}

/**
 * @tags Mg Controller
 * @summary getVendorListByBrokerid
 */
export function getVendorListByBrokerid(params: GetVendorListByBrokeridParams) {
  return request.get<AbstractResponse<object, MgBrokerVendor>>(
    `${URL}/api/mgcompany/${params.mgid}/broker/${params.tpidbroker}/vendor`
  );
}

export interface GetUserListByMgidParams {
  mgid: number;
}

export interface GetUserListByMgidAndJobParams {
  mgid: number;
  jobcode: string;
}

export function getUserListByMgidAndJob(params: GetUserListByMgidAndJobParams) {
  return request.get<AbstractResponse<object, MgUserResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/usersByJob/${params.jobcode}`
  );
}
/**
 * @tags Mg Controller
 * @summary getUserListByMgid
 */
export function getUserListByMgid(params: GetUserListByMgidParams) {
  return request.get<AbstractResponse<object, MgUserResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/users`
  );
}

export interface AddUserToMgCompanyParams {
  mgid: number;
  request: MgUsersRequest;
}

/**
 * @tags Mg Controller
 * @summary addUserToMgCompany
 */
export function addUserToMgCompany(params: AddUserToMgCompanyParams) {
  return request.post<AbstractResponse<object, MgUserResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/users`,
    params.request
  );
}

export interface RemoveUserFromMgCompanyParams {
  mgid: number;
  request: MgUsersRequest;
}

/**
 * @tags Mg Controller
 * @summary removeUserFromMgCompany
 */
export function removeUserFromMgCompany(params: RemoveUserFromMgCompanyParams) {
  return request.delete<AbstractResponse<object, MgUserResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/users`,
    params.request
  );
}

export interface GetUseProfileListByMgidParams {
  mgid: number;
  userid: number;
}

/**
 * @tags Mg Controller
 * @summary getUseProfileListByMgid
 */
export function getUseProfileListByMgid(params: GetUseProfileListByMgidParams) {
  return request.get<AbstractResponse<object, MgUserProfileResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/users/${params.userid}/profile`
  );
}

export interface AddUserProfileToMgCompanyParams {
  mgid: number;
  resquest: MgUserProfileRequest;
  userid: number;
}

/**
 * @tags Mg Controller
 * @summary addUserProfileToMgCompany
 */
export function addUserProfileToMgCompany(
  params: AddUserProfileToMgCompanyParams
) {
  return request.post<AbstractResponse<object, MgUserProfileResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/users/${params.userid}/profile`,
    params.resquest
  );
}

export interface RemoveUserProfileFromMgCompanyParams {
  mgid: number;
  request: MgUserProfileRequest;
  userid: number;
}

/**
 * @tags Mg Controller
 * @summary removeUserProfileFromMgCompany
 */
export function removeUserProfileFromMgCompany(
  params: RemoveUserProfileFromMgCompanyParams
) {
  return request.delete<AbstractResponse<object, MgUserProfileResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/users/${params.userid}/profile`,
    params.request
  );
}

export interface GetVendorListByCriteriaParams {
  mgid: number;
  name: string;
  status: string;
  surname: string;
  tpidbroker: number;
}

/**
 * @tags Mg Controller
 * @summary getVendorListByCriteria
 */
export function getVendorListByCriteria(params: GetVendorListByCriteriaParams) {
  return request.get<AbstractResponse<object, MgBrokerVendorResponse>>(
    `${URL}/api/mgcompany/${params.mgid}/vendor` +
    prepareQueryParams({
      name: params.name,
      status: params.status,
      surname: params.surname,
      tpidbroker: params.tpidbroker,
    } as any)
  );
}

export interface CreateVendorParams {
  mgid: number;
  vendorRequest: MgBrokerVendor;
}

/**
 * @tags Mg Controller
 * @summary createVendor
 */
export function createVendor(params: CreateVendorParams) {
  return request.post<AbstractResponse<MgBrokerVendor, object>>(
    `${URL}/api/mgcompany/${params.mgid}/vendor`,
    params.vendorRequest
  );
}

export interface GetVendorByIDParams {
  mgid: number;
  vendorid: number;
}

/**
 * @tags Mg Controller
 * @summary getVendorByID
 */
export function getVendorByID(params: GetVendorByIDParams) {
  return request.get<AbstractResponse<MgBrokerVendor, object>>(
    `${URL}/api/mgcompany/${params.mgid}/vendor/${params.vendorid}`
  );
}

export interface UpdateVendorParams {
  mgid: number;
  vendorRequest: MgBrokerVendor;
  vendorid: number;
}

/**
 * @tags Mg Controller
 * @summary updateVendor
 */
export function updateVendor(params: UpdateVendorParams) {
  return request.put<AbstractResponse<MgBrokerVendor, object>>(
    `${URL}/api/mgcompany/${params.mgid}/vendor/${params.vendorid}`,
    params.vendorRequest
  );
}

export interface UpdateVendorStatusParams {
  mgid: number;
  status: string;
  vendorid: number;
}

/**
 * @tags Mg Controller
 * @summary updateVendorStatus
 */
export function updateVendorStatus(params: UpdateVendorStatusParams) {
  return request.put<AbstractResponse<MgBrokerVendor, object>>(
    `${URL}/api/mgcompany/${params.mgid}/vendor/${params.vendorid}/${params.status}`
  );
}

/**
 * @tags Parameters Controller
 * @summary getMGList
 */
export function getMGList() {
  return request.get<AbstractResponse<object, MGCompanyList>>(
    `${URL}/api/mglist`
  );
}

export interface AddMgTaxListParams {
  request: MgTaxResponse;
}

/**
 * @tags Mg Controller
 * @summary addMgTaxList
 */
export function addMgTaxList(params: AddMgTaxListParams) {
  return request.post<AbstractResponse<MgTaxResponse, object>>(
    `${URL}/api/mgtax`,
    params.request
  );
}

export interface GetMgTaxListParams {
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary getMgTaxList
 */
export function getMgTaxList(params: GetMgTaxListParams) {
  return request.get<AbstractResponse<object, MgTaxResponse>>(
    `${URL}/api/mgtax/${params.mgid}`
  );
}

export interface RemoveMgTaxListParams {
  mgid: number;
  taxcode: string;
}

/**
 * @tags Mg Controller
 * @summary removeMgTaxList
 */
export function removeMgTaxList(params: RemoveMgTaxListParams) {
  return request.delete<AbstractResponse<MgTaxResponse, object>>(
    `${URL}/api/mgtax/${params.mgid}/${params.taxcode}`
  );
}

/**
 * @tags Mguserlanding Controller
 * @summary getMguserlandingBymgidUserid
 */
export function getMguserlandingBymgidUserid() {
  return request.get<AbstractResponse<object, MguserlandingResponse>>(
    `${URL}/api/mguserlanding`
  );
}

export interface AddMguserlandingBymgidUseridParams {
  request: Mguserlanding;
}

/**
 * @tags Mguserlanding Controller
 * @summary addMguserlandingBymgidUserid
 */
export function addMguserlandingBymgidUserid(
  params: AddMguserlandingBymgidUseridParams
) {
  return request.post<AbstractResponse<object, Mguserlanding>>(
    `${URL}/api/mguserlanding`,
    params.request
  );
}

export interface UpdateMguserlandingParams {
  partid: number;
  request: Mguserlanding;
}

/**
 * @tags Mguserlanding Controller
 * @summary UpdateMguserlanding
 */
export function UpdateMguserlanding(params: UpdateMguserlandingParams) {
  return request.put<AbstractResponse<object, Mguserlanding>>(
    `${URL}/api/mguserlanding/${params.partid}`,
    params.request
  );
}

export interface RemoveMguserlandingParams {
  partid: number;
}

/**
 * @tags Mguserlanding Controller
 * @summary removeMguserlanding
 */
export function removeMguserlanding(params: RemoveMguserlandingParams) {
  return request.delete<AbstractResponse<object, Mguserlanding>>(
    `${URL}/api/mguserlanding/${params.partid}`
  );
}

export interface GetOfferListParams {
  duration: number;
  filters: string;
  finamount: number;
  prcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getOfferList
 */

export interface GetParmessageByCriteriaParams {
  lancode: string;
  module: string;
  msgid: number;
  msglabel: string;
}

/**
 * @tags Par Message Controller
 * @summary getParmessageByCriteria
 */
export function getParmessageByCriteria(params: GetParmessageByCriteriaParams) {
  return request.get<AbstractResponse<object, ParMessageResponse>>(
    `${URL}/api/parMessage` +
    prepareQueryParams({
      lancode: params.lancode,
      module: params.module,
      msgid: params.msgid,
      msglabel: params.msglabel,
    } as any)
  );
}

export interface AddParMessageParams {
  request: ParMessage;
}

/**
 * @tags Par Message Controller
 * @summary addParMessage
 */
export function addParMessage(params: AddParMessageParams) {
  return request.post<AbstractResponse<ParMessage, object>>(
    `${URL}/api/parMessage`,
    params.request
  );
}

export interface UpdateParMessageParams {
  id: number;
  request: ParMessage;
}

/**
 * @tags Par Message Controller
 * @summary updateParMessage
 */
export function updateParMessage(params: UpdateParMessageParams) {
  return request.put<AbstractResponse<ParMessage, object>>(
    `${URL}/api/parMessage/${params.id}`,
    params.request
  );
}

export interface RemoveParMessageParams {
  id: number;
}

/**
 * @tags Par Message Controller
 * @summary removeParMessage
 */
export function removeParMessage(params: RemoveParMessageParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parMessage/${params.id}`
  );
}

export interface GetParameterByCriteriaParams {
  parcode?: string;
  parlabel?: string;
  parmodule?: string;
}

/**
 * @tags Parameters Controller
 * @summary getParameterByCriteria
 */
export function getParameterByCriteria(params: GetParameterByCriteriaParams) {
  return request.get<AbstractResponse<object, ParametersListResponse>>(
    `${URL}/api/parameters` +
    prepareQueryParams({
      parcode: params.parcode,
      parlabel: params.parlabel,
      parmodule: params.parmodule,
    } as any)
  );
}

export interface CreateParameterParams {
  parameterRequest: ParameterRequest;
}

/**
 * @tags Parameters Controller
 * @summary createParameter
 */
export function createParameter(params: CreateParameterParams) {
  return request.post<AbstractResponse<ParameterResponse, object>>(
    `${URL}/api/parameters`,
    params.parameterRequest
  );
}

export interface GetParameterDetailParams {
  parcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getParameterDetail
 */
export function getParameterDetail(params: GetParameterDetailParams) {
  return request.get<AbstractResponse<ParameterResponse, object>>(
    `${URL}/api/parameters/${params.parcode}`
  );
}

export interface UpdateParameterParams {
  parameterRequest: ParameterRequest;
  parcode: string;
}

/**
 * @tags Parameters Controller
 * @summary updateParameter
 */
export function updateParameter(params: UpdateParameterParams) {
  return request.put<AbstractResponse<ParameterResponse, object>>(
    `${URL}/api/parameters/${params.parcode}`,
    params.parameterRequest
  );
}

export interface GetParametersFilteringListParams {
  filtermode?: string;
  parcode: string;
  parlabel: string;
  partype?: string;
}

/**
 * @tags Parameters Controller
 * @summary getParametersFilteringList
 */
export function getParametersFilteringList(
  params: GetParametersFilteringListParams
) {
  return request.get<AbstractResponse<object, ParametersLabel>>(
    `${URL}/api/parametersFilteringList` +
    prepareQueryParams({
      filtermode: params.filtermode,
      parcode: params.parcode,
      parlabel: params.parlabel,
      partype: params.partype,
    } as any)
  );
}

export interface GetParcontrolByCriteriaParams {
  ccode: string;
  centity: string;
}

/**
 * @tags Parcontrolconfig Controller
 * @summary getParcontrolByCriteria
 */
export function getParcontrolByCriteria(params: GetParcontrolByCriteriaParams) {
  return request.get<AbstractResponse<object, ViewParControl>>(
    `${URL}/api/parcontrol` +
    prepareQueryParams({
      ccode: params.ccode,
      centity: params.centity,
    } as any)
  );
}

export interface UpdateParControlParams {
  ccode: string;
  request: ParControlRequest;
}

/**
 * @tags Parcontrolconfig Controller
 * @summary updateParControl
 */
export function updateParControl(params: UpdateParControlParams) {
  return request.put<AbstractResponse<ParControlResponse, object>>(
    `${URL}/api/parcontrol/${params.ccode}`,
    params.request
  );
}
export interface GetParcontrolconfigByCriteriaParams {
  ccode: string;
  centity: string;
  clabel: string;
}

/**
 * @tags Parcontrolconfig Controller
 * @summary getParcontrolconfigByCriteria
 */
export function getParcontrolconfigByCriteria(
  params: GetParcontrolconfigByCriteriaParams
) {
  return request.get<AbstractResponse<object, ViewParControlConfigResponse>>(
    `${URL}/api/parcontrolconfig` +
    prepareQueryParams({
      ccode: params.ccode,
      centity: params.centity,
      clabel: params.clabel,
    } as any)
  );
}

export interface AddParcontrolconfigParams {
  request: Parcontrolconfig;
}

/**
 * @tags Parcontrolconfig Controller
 * @summary addParcontrolconfig
 */
export function addParcontrolconfig(params: AddParcontrolconfigParams) {
  return request.post<AbstractResponse<Parcontrolconfig, object>>(
    `${URL}/api/parcontrolconfig`,
    params.request
  );
}

export interface UpdateParcontrolconfigParams {
  ccid: number;
  request: Parcontrolconfig;
}

/**
 * @tags Parcontrolconfig Controller
 * @summary updateParcontrolconfig
 */
export function updateParcontrolconfig(params: UpdateParcontrolconfigParams) {
  return request.put<AbstractResponse<Parcontrolconfig, object>>(
    `${URL}/api/parcontrolconfig/${params.ccid}`,
    params.request
  );
}

export interface RemoveParcontrolconfigParams {
  ccid: number;
}

/**
 * @tags Parcontrolconfig Controller
 * @summary removeParcontrolconfig
 */
export function removeParcontrolconfig(params: RemoveParcontrolconfigParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parcontrolconfig/${params.ccid}`
  );
}

/**
 * @tags Par Currency Controller
 * @summary getParCurrency
 */
export function getParCurrency() {
  return request.get<AbstractResponse<object, ParCurrencyResponse>>(
    `${URL}/api/parcurrency`
  );
}

export interface AddParCurrencyParams {
  request: ParCurrencyResponse;
}

/**
 * @tags Par Currency Controller
 * @summary addParCurrency
 */
export function addParCurrency(params: AddParCurrencyParams) {
  return request.post<AbstractResponse<ParCurrencyResponse, object>>(
    `${URL}/api/parcurrency`,
    params.request
  );
}

export interface UpdateParCurrencyParams {
  currcode?: string;
  request: ParCurrencyResponse;
}

/**
 * @tags Par Currency Controller
 * @summary updateParCurrency
 */
export function updateParCurrency(params: UpdateParCurrencyParams) {
  return request.put<AbstractResponse<ParCurrencyResponse, object>>(
    `${URL}/api/parcurrency/${params.currcode}`,
    params.request
  );
}

export interface RemoveParCurrencyParams {
  currcode: string;
}

/**
 * @tags Par Currency Controller
 * @summary removeParCurrency
 */
export function removeParCurrency(params: RemoveParCurrencyParams) {
  return request.delete<AbstractResponse<ParCurrencyResponse, object>>(
    `${URL}/api/parcurrency/${params.currcode}`
  );
}

export interface CreateParListParams {
  parListRequest: ParListRequest;
}

/**
 * @tags Parameters Controller
 * @summary createParList
 */
export function createParList(params: CreateParListParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/parlist`,
    params.parListRequest
  );
}

export interface GetParListParams {
  parcode: string;
  tpid: number;
}


/**
 * @tags Parameters Controller
 * @summary getParList
 */
export function getParList(params: GetParListParams) {
  return request.get<AbstractResponse<object, ViewParList>>(
    `${URL}/api/parlistbroker/${params.parcode}/${params.tpid}`
  );
}
export interface GetParAddressParams {
  zipcode: String;
  cityOrcityLabel: String;
}
export function getParAddress(params: GetParAddressParams) {
  return request.get<AbstractResponse<object, ParaddressResponse>>(
    `${URL}/api/paraddress` + prepareQueryParams({
      zipcode: params.zipcode,
      cityOrcityLabel: params.cityOrcityLabel,
    } as any)

  );
}



export interface GetParAddressParams {
  zipcode: String;
}
export function getDistinctCityByZipCode(params: GetParAddressParams) {
  return request.get<AbstractResponse<object, ParaddressResponse>>(
    `${URL}/api/paraddress/cities` + prepareQueryParams({
      zipcode: params.zipcode,
    } as any)

  );
}


export interface GetZipcodesByCityParams {
  cityOrcityLabel: String;
}

export function getZipcodesByCity(params: GetZipcodesByCityParams) {
  return request.get<AbstractResponse<object, string>>(
    `${URL}/api/paraddress/zipcodes` + prepareQueryParams({
      cityOrcityLabel: params.cityOrcityLabel,
    } as any)

  );
}


export interface GetParListByMGParams {
  mgid: number;
  parcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getParListByMG
 */
export function getParListByMG(params: GetParListByMGParams) {
  return request.get<AbstractResponse<object, ViewParList>>(
    `${URL}/api/parlist/${params.parcode}/${params.mgid}`
  );
}


export interface UpdateParListParams {
  parListRequest: ParListRequest;
  parcode: string;
  parvalue: string;
}

/**
 * @tags Parameters Controller
 * @summary updateParList
 */
export function updateParList(params: UpdateParListParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/parlist/${params.parcode}/${params.parvalue}`,
    params.parListRequest
  );
}

export interface RemoveParListParams {
  parcode: string;
  parvalue: string;
  req: ParListRequest;
}

/**
 * @tags Parameters Controller
 * @summary removeParList
 */
export function removeParList(params: RemoveParListParams) {
  return request.delete<AbstractResponse<ParameterResponse, object>>(
    `${URL}/api/parlist/${params.parcode}/${params.parvalue}`,
    params.req
  );
}

export interface GetChildParListParams {
  parcode: string;
  parvalueparent: string;
}

/**
 * @tags Parameters Controller
 * @summary getChildParList
 */
export function getChildParList(params: GetChildParListParams) {
  return request.get<AbstractResponse<object, ViewParListResponse>>(
    `${URL}/api/parlistChild` +
    prepareQueryParams({
      parcode: params.parcode,
      parvalueparent: params.parvalueparent,
    } as any)
  );
}


export interface AddMGParListParams {
  req: MGParListRequest;
}

/**
 * @tags Parameters Controller
 * @summary addMGParList
 */
export function addMGParList(params: AddMGParListParams) {
  return request.post<AbstractResponse<object, ViewParList>>(
    `${URL}/api/parlistMG`,
    params.req
  );
}

export interface RemoveMGParListParams {
  req: MGParListRequest;
}

/**
 * @tags Parameters Controller
 * @summary removeMGParList
 */
export function removeMGParList(params: RemoveMGParListParams) {
  return request.delete<AbstractResponse<object, ViewParList>>(
    `${URL}/api/parlistMG`,
    params.req
  );
}

export interface GetParListOfferParams {
  offerid: number;
  parcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getParListOffer
 */
export function getParListOffer(params: GetParListOfferParams) {
  return request.get<AbstractResponse<object, ViewParList>>(
    `${URL}/api/parlistOffer` +
    prepareQueryParams({
      offerid: params.offerid,
      parcode: params.parcode,
    } as any)
  );
}

export interface GetParListOfferFilteringParams {
  mgid: number;
  offerid: number;
  parcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getParListOfferFiltering
 */
export function getParListOfferFiltering(
  params: GetParListOfferFilteringParams
) {
  return request.get<AbstractResponse<object, ViewParList>>(
    `${URL}/api/parlistOfferFiltering` +
    prepareQueryParams({
      mgid: params.mgid,
      offerid: params.offerid,
      parcode: params.parcode,
    } as any)
  );
}

export interface AddParListOfferFilteringParams {
  req: MGOfferParFilteringRequest;
}

/**
 * @tags Parameters Controller
 * @summary addParListOfferFiltering
 */
export function addParListOfferFiltering(
  params: AddParListOfferFilteringParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/parlistOfferFiltering`,
    params.req
  );
}

export interface RemoveParListOfferFilteringParams {
  req: MGOfferParFilteringRequest;
}

/**
 * @tags Parameters Controller
 * @summary removeParListOfferFiltering
 */
export function removeParListOfferFiltering(
  params: RemoveParListOfferFilteringParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parlistOfferFiltering`,
    params.req
  );
}

export interface GetParListProductParams {
  parcode: string;
  prcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getParListProduct
 */
export function getParListProduct(params: GetParListProductParams) {
  return request.get<AbstractResponse<object, ViewParList>>(
    `${URL}/api/parlistProduct` +
    prepareQueryParams({
      parcode: params.parcode,
      prcode: params.prcode,
    } as any)
  );
}

export interface GetParListProductFilteringParams {
  mgid: number;
  parcode: string;
  prcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getParListProductFiltering
 */
export function getParListProductFiltering(
  params: GetParListProductFilteringParams
) {
  return request.get<AbstractResponse<object, ViewParList>>(
    `${URL}/api/parlistProductFiltering` +
    prepareQueryParams({
      mgid: params.mgid,
      parcode: params.parcode,
      prcode: params.prcode,
    } as any)
  );
}

export interface AddParListProductFilteringParams {
  req: MGProductParFilteringRequest;
}

/**
 * @tags Parameters Controller
 * @summary addParListProductFiltering
 */
export function addParListProductFiltering(
  params: AddParListProductFilteringParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/parlistProductFiltering`,
    params.req
  );
}

export interface RemoveParListProductFilteringParams {
  req: MGProductParFilteringRequest;
}

/**
 * @tags Parameters Controller
 * @summary removeParListProductFiltering
 */
export function removeParListProductFiltering(
  params: RemoveParListProductFilteringParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parlistProductFiltering`,
    params.req
  );
}

export interface GetParRateListbyCriteriaParams {
  ratecode: string;
  ratelabel?: string;
  ratedescription: string;
  ratetype: string;
  ratecodespread?:number;
  ratecategory:string
}

/**
 * @tags Par Rate Controller
 * @summary getParRateListbyCriteria
 */
export function getParRateListbyCriteria(
  params: GetParRateListbyCriteriaParams
) {
  return request.get<AbstractResponse<object, ParRateResponse>>(
    `${URL}/api/parrate` +
    prepareQueryParams({
      ratecode: params.ratecode,
      ratedescription: params.ratedescription,
      ratetype: params.ratetype,
      ratecategory:params.ratecategory

    } as any)
  );
}
export interface ParRateFormulaResponse { 
  id:number;
  flagcomplex: boolean;
  formulacode: string;
  formulalabel: string;
  formuladescription:string
  formulastatus: string;
  formulastatuslabel: string;
  formulatype: string;
  formulatypelabel: string;
  ratecode: string;
  ratelabel: string;
  ratevalue:number;
  rateriskcost: number;
  ratespread: number;
  ceilingrate: number;
  ceilingdefaultrate: number;
  floorrate: number;
  floordefaultrate: number;
  calid: number;
  ratecodespread:string;
  flagbonification:boolean;
 }
export interface GetParRateFormulaBycodeParams {
  formulacode: string;

}

export function getParRateFormulaByFormulaCode(
  params: GetParRateFormulaBycodeParams
) {
  return request.get<AbstractResponse< ParRateFormulaResponse,object>>(
    `${URL}/api/parrateformulabycode/${params.formulacode}`
  );
}

export interface AddParRateParams {
  request: ParRateResponse;
}

/**
 * @tags Par Rate Controller
 * @summary addParRate
 */
export function addParRate(params: AddParRateParams) {
  return request.post<AbstractResponse<ParRateResponse, object>>(
    `${URL}/api/parrate`,
    params.request
  );
}

export interface GetParRateCodeParams {
  ratecode: string;
}

/**
 * @tags Par Rate Controller
 * @summary getParRateCode
 */
export function getParRateCode(params: GetParRateCodeParams) {
  return request.get<AbstractResponse<ParRateResponse, object>>(
    `${URL}/api/parrate/${params.ratecode}`
  );
}

export interface UpdateParRateParams {
  ratecode: string;
  request: ParRateResponse;
}

/**
 * @tags Par Rate Controller
 * @summary updateParRate
 */
export function updateParRate(params: UpdateParRateParams) {
  return request.put<AbstractResponse<ParRateResponse, object>>(
    `${URL}/api/parrate/${params.ratecode}`,
    params.request
  );
}

export interface UpdateParRateStatusParams {
  ratecode: string;
  ratestatus: string;
}

/**
 * @tags Par Rate Controller
 * @summary updateParRateStatus
 */
export function updateParRateStatus(params: UpdateParRateStatusParams) {
  return request.put<AbstractResponse<ParRateResponse, object>>(
    `${URL}/api/parrate/${params.ratecode}/${params.ratestatus}`
  );
}

export interface AddParRateValueParams {
  request: ParRateValueResponse;
}

/**
 * @tags Par Rate Controller
 * @summary addParRateValue
 */
export function addParRateValue(params: AddParRateValueParams) {
  return request.post<AbstractResponse<ParRateValue, object>>(
    `${URL}/api/parratevalue`,
    params.request
  );
}

export interface UpdateParRateValueParams {
  ratevalueid: number;
  request: ParRateValue;
}

/**
 * @tags Par Rate Controller
 * @summary updateParRateValue
 */
export function updateParRateValue(params: UpdateParRateValueParams) {
  return request.put<AbstractResponse<ParRateValue, object>>(
    `${URL}/api/parratevalue/${params.ratevalueid}`,
    params.request
  );
}

export interface GetParsystemByCriteriaParams {
  parcode: string;
  parlabel: string;
  parmodule?: string;
}

/**
 * @tags Parameters Controller
 * @summary getParsystemByCriteria
 */
export function getParsystemByCriteria(params: GetParsystemByCriteriaParams) {
  return request.get<AbstractResponse<object, ViewParValueSystem>>(
    `${URL}/api/parsystem` +
    prepareQueryParams({
      parcode: params.parcode,
      parlabel: params.parlabel,
      parmodule: params.parmodule,
    } as any)
  );
}



export interface ParTaxListParams {
  creationdate: string;
  itaxlabel: string;
  taxtype: string;
  begindate: string;
  enddate: string;
  taxflow: string;
}


/**
 * @tags Par Tax Controller
 * @summary getParTaxList
 */
export function getParTaxList(params: ParTaxListParams) {
  return request.get<AbstractResponse<object, ParTaxResponse2>>(
    `${URL}/api/partax` +
    prepareQueryParams({
      creationdate: params.creationdate,
      itaxlabel: params.itaxlabel,
      taxtype: params.taxtype,
      begindate: params.begindate,
      enddate: params.enddate,
      taxflow: params.taxflow,

    } as any)
  );
}

export interface AddParTaxParams {
  request: ParTaxResponse2;
}

/**
 * @tags Par Tax Controller
 * @summary addParTax
 */
export function addParTax(params: AddParTaxParams) {
  return request.post<AbstractResponse<ParTaxResponse2, object>>(
    `${URL}/api/partax`,
    params.request
  );
}

export interface GetParTaxCodeParams {
  taxcode: string;
}

/**
 * @tags Par Tax Controller
 * @summary getParTaxCode
 */
export function getParTaxCode(params: GetParTaxCodeParams) {
  return request.get<AbstractResponse<ParTaxResponse2, object>>(
    `${URL}/api/partax/${params.taxcode}`
  );
}

export interface UpdateParTaxParams {
  request: ParTaxResponse2;
  taxcode: string;
}

/**
 * @tags Par Tax Controller
 * @summary updateParTax
 */
export function updateParTax(params: UpdateParTaxParams) {
  return request.put<AbstractResponse<ParTaxResponse2, object>>(
    `${URL}/api/partax/${params.taxcode}`,
    params.request
  );
}

export interface UpdateParTaxStatusParams {
  taxcode: string;
  taxstatus: string;
}

/**
 * @tags Par Tax Controller
 * @summary updateParTaxStatus
 */
export function updateParTaxStatus(params: UpdateParTaxStatusParams) {
  return request.put<AbstractResponse<ParTaxResponse2, object>>(
    `${URL}/api/partax/${params.taxcode}/${params.taxstatus}`
  );
}

export interface AddParTaxRateParams {
  request: ParTaxRateResponse;
}

/**
 * @tags Par Tax Controller
 * @summary addParTaxRate
 */
export function addParTaxRate(params: AddParTaxRateParams) {
  return request.post<AbstractResponse<ParTaxRate, object>>(
    `${URL}/api/partaxrate`,
    params.request
  );
}

export interface UpdateParTaxRateParams {
  request: ParTaxRate;
  taxrateid: number;
}

/**
 * @tags Par Tax Controller
 * @summary updateParTaxRate
 */
export function updateParTaxRate(params: UpdateParTaxRateParams) {
  return request.put<AbstractResponse<ParTaxRate, object>>(
    `${URL}/api/partaxrate/${params.taxrateid}`,
    params.request
  );
}

export interface GetParTranscodingListByCriteriaParams {
  parcode: string;
  parexternalvalue: string;
  parvalue: string;
}

/**
 * @tags Par Transcoding Controller
 * @summary GetParTranscodingListByCriteria
 */
export function GetParTranscodingListByCriteria(
  params: GetParTranscodingListByCriteriaParams
) {
  return request.get<AbstractResponse<object, PartranscodingResponse>>(
    `${URL}/api/partranscoding` +
    prepareQueryParams({
      parcode: params.parcode,
      parexternalvalue: params.parexternalvalue,
      parvalue: params.parvalue,
    } as any)
  );
}

export interface AddParTranscodingParams {
  request: PartranscodingResponse;
}

/**
 * @tags Par Transcoding Controller
 * @summary addParTranscoding
 */
export function addParTranscoding(params: AddParTranscodingParams) {
  return request.post<AbstractResponse<PartranscodingResponse, object>>(
    `${URL}/api/partranscoding`,
    params.request
  );
}

export interface GetParTranscodingByIdParams {
  associd: number;
}

/**
 * @tags Par Transcoding Controller
 * @summary GetParTranscodingById
 */
export function GetParTranscodingById(params: GetParTranscodingByIdParams) {
  return request.get<AbstractResponse<PartranscodingResponse, object>>(
    `${URL}/api/partranscoding/${params.associd}`
  );
}

export interface UpdatePranscodingByIdParams {
  associd: number;
  request: PartranscodingResponse;
}

/**
 * @tags Par Transcoding Controller
 * @summary updatePranscodingById
 */
export function updatePranscodingById(params: UpdatePranscodingByIdParams) {
  return request.put<AbstractResponse<PartranscodingResponse, object>>(
    `${URL}/api/partranscoding/${params.associd}`,
    params.request
  );
}

export interface RemoveParTranscodingByIdParams {
  associd: number;
}

/**
 * @tags Par Transcoding Controller
 * @summary removeParTranscodingById
 */
export function removeParTranscodingById(
  params: RemoveParTranscodingByIdParams
) {
  return request.delete<AbstractResponse<PartranscodingResponse, object>>(
    `${URL}/api/partranscoding/${params.associd}`
  );
}

export interface GetParvalueByCriteriaParams {
  mgid?: number | undefined;
  parcode: string;
  parlabel: string;
}

/**
 * @tags Parameters Controller
 * @summary getParvalueByCriteria
 */
export function getParvalueByCriteria(params: GetParvalueByCriteriaParams) {
  return request.get<AbstractResponse<object, ViewParValue>>(
    `${URL}/api/parvalue` +
    prepareQueryParams({
      mgid: params.mgid,
      parcode: params.parcode,
      parlabel: params.parlabel,
    } as any)
  );
}

export interface UpdateParvalueParams {
  req: ParvalueRequest;
}

/**
 * @tags Parameters Controller
 * @summary updateParvalue
 */
export function updateParvalue(params: UpdateParvalueParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/parvalue`,
    params.req
  );
}

export interface SetParvalueDefaultParams {
  req: ParvalueDefaultRequest;
}

/**
 * @tags Parameters Controller
 * @summary setParvalueDefault
 */
export function setParvalueDefault(params: SetParvalueDefaultParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/parvalueDefault`,
    params.req
  );
}

export interface GetParvalueOfferByCriteriaParams {
  mgid: number;
  offerid: number;
  parcode: string;
  parlabel: string;
}

/**
 * @tags Parameters Controller
 * @summary getParvalueOfferByCriteria
 */
export function getParvalueOfferByCriteria(
  params: GetParvalueOfferByCriteriaParams
) {
  return request.get<AbstractResponse<object, ViewParValueOffer>>(
    `${URL}/api/parvalueOffer` +
    prepareQueryParams({
      mgid: params.mgid,
      offerid: params.offerid,
      parcode: params.parcode,
      parlabel: params.parlabel,
    } as any)
  );
}

export interface GetParvalueProductByCriteriaParams {
  mgid: number;
  parcode: string;
  parlabel: string;
  prcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getParvalueProductByCriteria
 */
export function getParvalueProductByCriteria(
  params: GetParvalueProductByCriteriaParams
) {
  return request.get<AbstractResponse<object, ViewParValueProduct>>(
    `${URL}/api/parvalueProduct` +
    prepareQueryParams({
      mgid: params.mgid,
      parcode: params.parcode,
      parlabel: params.parlabel,
      prcode: params.prcode,
    } as any)
  );
}

export interface GetProductParvalueParams {
  mgid: number;
  parcode: string;
  prcode: string;
}
export function getProductParvalue(params: GetProductParvalueParams) {
  return request.get<AbstractResponse<String, object>>(
    `${URL}/api/productParvalue` +
    prepareQueryParams({
      mgid: params.mgid,
      parcode: params.parcode,
      prcode: params.prcode,
    } as any)
  );
}

/**
 * @tags Parameters Controller
 * @summary getProductList
 */
export function getProductList() {
  return request.get<AbstractResponse<object, ParProductResponse>>(
    `${URL}/api/productlist`
  );
}

export interface GetProductListByMgParams {
  mgid: number;
}

/**
 * @tags Parameters Controller
 * @summary getProductListByMg
 */
export function getProductListByMg(params: GetProductListByMgParams) {
  return request.get<AbstractResponse<object, ParProductResponse>>(
    `${URL}/api/productlistByMg` +
    prepareQueryParams({ mgid: params.mgid } as any)
  );
}

export interface GetParTaxListByTaxFlowParams {
  taxflow: string;
}

/**
 * @tags Parameters Controller
 * @summary getParTaxListByTaxFlow
 */
export function getParTaxListByTaxFlow(params: GetParTaxListByTaxFlowParams) {
  return request.get<AbstractResponse<object, ParTaxResponse>>(
    `${URL}/api/taxes/flow/${params.taxflow}`
  );
}

export interface GetParTaxListByTaxCodeParams {
  taxcode: string;
}

/**
 * @tags Parameters Controller
 * @summary getParTaxListByTaxCode
 */
export function getParTaxListByTaxCode(params: GetParTaxListByTaxCodeParams) {
  return request.get<AbstractResponse<object, ParTaxResponse>>(
    `${URL}/api/taxes/${params.taxcode}`
  );
}

export interface GetUsersByAnyRefParams {
  email: string;
  locked: boolean;
  mgid: number;
  mobile: string;
  name: string;
  phone: string;
  status: string;
  surname: string;
  username: string;
  userrole: string;
  userid: number | undefined;
  useridmanager: number | undefined;
}

/**
 * @tags Users Controller
 * @summary getUsersByAnyRef
 */
export function getUsersByAnyRef(params: GetUsersByAnyRefParams) {
  return request.get<AbstractResponse<object, Users>>(
    `${URL}/api/users` +
    prepareQueryParams({
      email: params.email,
      locked: params.locked,
      mgid: params.mgid,
      mobile: params.mobile,
      name: params.name,
      phone: params.phone,
      status: params.status,
      surname: params.surname,
      username: params.username,
      userrole: params.userrole,
      userid: params.userid,
      useridmanager: params.useridmanager,
    } as any)
  );
}

export function getAllUsersListByAnyRef(params: GetUsersByAnyRefParams) {
  return request.get<AbstractResponse<object, Users>>(
    `${URL}/api/usersList` +
    prepareQueryParams({
      email: params.email,
      locked: params.locked,
      mgid: params.mgid,
      mobile: params.mobile,
      name: params.name,
      phone: params.phone,
      status: params.status,
      surname: params.surname,
      username: params.username,
      userrole: params.userrole,
      userid: params.userid,
      useridmanager: params.useridmanager,
    } as any)
  );
}

export interface CreateUserParams {
  userRequest: UserRequest;
}

/**
 * @tags Users Controller
 * @summary createUser
 */
export function createUser(params: CreateUserParams) {
  return request.post<AbstractResponse<Users, object>>(
    `${URL}/api/users`,
    params.userRequest
  );
}

/**
 * @tags Users Controller
 * @summary getMyFavorite
 */

/**
 * @tags Users Controller
 * @summary getMyMgCompanyList
 */
export function getMyMgCompanyList() {
  return request.get<AbstractResponse<object, MGCompanyListResponse>>(
    `${URL}/api/users/mymgcompanylist`
  );
}

export function getMgCompanyList() {
  return request.get<AbstractResponse<object, MGCompanyListResponse>>(
    `${URL}/api/users/mgcompanylist`
  );
}

export function getMyCurrentMgCompany() {
  return request.get<AbstractResponse<MGCompanyListResponse, object>>(
    `${URL}/api/users/myCurrentMgCompany`
  );
}
export interface GetParValuesByUserParams {
  mgid: number;
  parcode: string;
  userid: number;
}
export interface GetMyParValuesParams {
  parcode: string;
}

/**
 * @tags Users Controller
 * @summary getParValuesByUser
 */
export function getParValuesByUser(params: GetParValuesByUserParams) {
  return request.get<AbstractResponse<object, MgUsersParFilteringResponse>>(
    `${URL}/api/users/parfilering` +
    prepareQueryParams({
      mgid: params.mgid,
      parcode: params.parcode,
      userid: params.userid,
    } as any)
  );
}
/**
 * @tags Users Controller
 * @summary getMyParValues
 */
export function getMyParValues(params: GetMyParValuesParams) {
  return request.get<AbstractResponse<object, MgUsersParFilteringResponse>>(
    `${URL}/api/users/myParfilering` +
    prepareQueryParams({
      parcode: params.parcode,
    } as any)
  );
}

export interface GetUserByIDParams {
  userid: number;
}

/**
 * @tags Users Controller
 * @summary getUserByID
 */
export function getUserByID(params: GetUserByIDParams) {
  return request.get<AbstractResponse<Users, object>>(
    `${URL}/api/users/${params.userid}`
  );
}

export interface UpdateUserParams {
  userRequest: UserRequest;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary updateUser
 */
export function updateUser(params: UpdateUserParams) {
  return request.put<AbstractResponse<Users, object>>(
    `${URL}/api/users/${params.userid}`,
    params.userRequest
  );
}

export interface ChangeMyPasswordParams {
  request: changePwdRequest;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary changeMyPassword
 */
export function changeMyPassword(params: ChangeMyPasswordParams) {
  return request.put<AbstractResponse<Users, object>>(
    `${URL}/api/users/${params.userid}/changepassword`,
    params.request
  );
}

export interface EnableDisableUserParams {
  status: string;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary enableDisableUser
 */
export function enableDisableUser(params: EnableDisableUserParams) {
  return request.put<AbstractResponse<Users, object>>(
    `${URL}/api/users/${params.userid}/enable/${params.status}`
  );
}

export interface InitUserPasswordParams {
  userid: number;
}

/**
 * @tags Users Controller
 * @summary initUserPassword
 */
export function initUserPassword(params: InitUserPasswordParams) {
  return request.put<AbstractResponse<Users, object>>(
    `${URL}/api/users/${params.userid}/initpassword`
  );
}

export interface LockUnlockUserParams {
  lock: boolean;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary lockUnlockUser
 */
export function lockUnlockUser(params: LockUnlockUserParams) {
  return request.put<AbstractResponse<Users, object>>(
    `${URL}/api/users/${params.userid}/lock/${params.lock}`
  );
}

export interface GetUserMgCompanyListParams {
  userid: number;
}

/**
 * @tags Users Controller
 * @summary getUserMgCompanyList
 */
export function getUserMgCompanyList(params: GetUserMgCompanyListParams) {
  return request.get<AbstractResponse<object, MGCompanyListResponse>>(
    `${URL}/api/users/${params.userid}/mgcompanylist`
  );
}

export interface GetParFilteringByUserParams {
  userid: number;
}

/**
 * @tags Users Controller
 * @summary getParFilteringByUser
 */
export function getParFilteringByUser(params: GetParFilteringByUserParams) {
  return request.get<AbstractResponse<object, MgUsersParFilteringResponse>>(
    `${URL}/api/users/${params.userid}/parfilering`
  );
}

export interface CreateUserParFilteringParams {
  request: MgUsersParFiltering;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary createUserParFiltering
 */
export function createUserParFiltering(params: CreateUserParFilteringParams) {
  return request.post<AbstractResponse<MgUsersParFilteringResponse, object>>(
    `${URL}/api/users/${params.userid}/parfilering`,
    params.request
  );
}

export interface RemoveUserParFilteringParams {
  filterid: number;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary removeUserParFiltering
 */
export function removeUserParFiltering(params: RemoveUserParFilteringParams) {
  return request.delete<AbstractResponse<object, MgUsersParFilteringResponse>>(
    `${URL}/api/users/${params.userid}/parfilering/${params.filterid}`
  );
}

export interface UpdateMyWorkingSessionParams {
  request: UserSessionParameters;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary updateMyWorkingSession
 */
export function updateMyWorkingSession(params: UpdateMyWorkingSessionParams) {
  return request.put<AbstractResponse<Users, object>>(
    `${URL}/api/users/${params.userid}/updateMyWorkingSession`,
    params.request
  );
}

/**
 * @tags Parameters Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}
export interface GetMGBankAccountListParams {
  mgid: number;
}

/**
 * @tags Mg Controller
 * @summary getMGBankAccountList
 */
export function getMGBankAccountList(params: GetMGBankAccountListParams) {
  return request.get<AbstractResponse<object, MgBankAccountResponse>>(
    `${URL}/api/mgcompany/mgbk/${params.mgid}`
  );
}

export interface AddMGBankAccountParams {
  request: MgBankAccount;
}

/**
 * @tags Mg Controller
 * @summary AddMGBankAccount
 */
export function AddMGBankAccount(params: AddMGBankAccountParams) {
  return request.post<AbstractResponse<MgBankAccount, object>>(
    `${URL}/api/mgcompany/mgbk`,
    params.request
  );
}

export interface UpdateMGBankAccountParams {
  accid: number;
  request: MgBankAccount;
}

/**
 * @tags Mg Controller
 * @summary updateMGBankAccount
 */
export function updateMGBankAccount(params: UpdateMGBankAccountParams) {
  return request.put<AbstractResponse<MgBankAccount, object>>(
    `${URL}/api/mgcompany/mgbk/${params.accid}`,
    params.request
  );
}

export interface DeleteMGBankAccountParams {
  accid: number;
}

/**
 * @tags Mg Controller
 * @summary deleteMGBankAccount
 */
export function deleteMGBankAccount(params: DeleteMGBankAccountParams) {
  return request.delete<AbstractResponse<MgBankAccount, object>>(
    `${URL}/api/mgcompany/mgbk/${params.accid}`
  );
}

export interface UpdateStatusMGBankAccountParams {
  accid: number;
  status: string;
}

/**
 * @tags Mg Controller
 * @summary updateStatusMGBankAccount
 */
export function updateStatusMGBankAccount(
  params: UpdateStatusMGBankAccountParams
) {
  return request.put<AbstractResponse<MgBankAccount, object>>(
    `${URL}/api/mgcompany/mgbk/${params.accid}/${params.status}`
  );
}

export interface MGCompany {
  countcode: string;
  currcode: string;
  lancode: string;
  mgbankissuer: string;
  mgcapital: string;
  mgemail: string;
  mgfiscalcity: string;
  mgfiscalid: string;
  mgfree1: string;
  mgfree2: string;
  mgfree3: string;
  mgfree4: string;
  mgfree5: string;
  mgid: number;
  mglegalform: string;
  mgmainadrcity: string;
  mgmainadrcountry: string;
  mgmainadrregion: string;
  mgmainadrstreet1: string;
  mgmainadrstreet2: string;
  mgmainadrzipcode: string;
  mgmarketingname: string;
  mgname: string;
  mgreference: string;
  mgsignatoryname: string;
  mgsignatoryposition: string;
  mgsocialmedia: string;
  mgtaxid: string;
  mgtaxmode: string;
  mgtel1: string;
  mgtel2: string;
  mgwebsite: string;
}

export interface Parcolunpaidlevels {
  coltargetstatus: string;
  flagautoexecute: boolean;
  collevel: string;
  mgid: number;
  nbdaysmax: number;
  nbdaysmin: number;
  parcollevelid: number;
  taskidtarget: number;
}

export interface UpdatemgcompanyParams {
  mgid: number;
  request: MGCompany;
}

/**
 * @tags Mg Controller
 * @summary Updatemgcompany
 */
export function Updatemgcompany(params: UpdatemgcompanyParams) {
  return request.put<AbstractResponse<MGCompanyResponse, object>>(
    `${URL}/api/mgcompany/${params.mgid}`,
    params.request
  );
}

export interface GetParbankBycriteriaParams {
  bkbic: string;
  bkcode?: string;
  bkibanprefix?: string;
  bkname: string;
  countcode: string;
}

/**
 * @tags Parbank Controller
 * @summary getParbankBycriteria
 */
export function getParbankBycriteria(params: GetParbankBycriteriaParams) {
  return request.get<AbstractResponse<object, Parbank>>(
    `${URL}/api/parbank` +
    prepareQueryParams({
      bkbic: params.bkbic,
      bkcode: params.bkcode,
      bkibanprefix: params.bkibanprefix,
      bkname: params.bkname,
      countcode: params.countcode,
    } as any)
  );
}

export interface GetParbankByBkcodeParams {
  bkcode?: string;
}

/**
 * @tags Parbank Controller
 * @summary getParbankByBkcode
 */
export function getParbankByBkcode(params: GetParbankByBkcodeParams) {
  return request.get<AbstractResponse<Parbank, object>>(
    `${URL}/api/bank/${params.bkcode}`
  );
}
export interface AddParbankParams {
  request: Parbank;
}

/**
 * @tags Parbank Controller
 * @summary addParbank
 */
export function addParbank(params: AddParbankParams) {
  return request.post<AbstractResponse<Parbank, object>>(
    `${URL}/api/parbank`,
    params.request
  );
}
export interface UpdateParbankParams {
  bkcode?: string;
  request: Parbank;
}

/**
 * @tags Parbank Controller
 * @summary updateParbank
 */
export function updateParbank(params: UpdateParbankParams) {
  return request.put<AbstractResponse<Parbank, object>>(
    `${URL}/api/parbank/${params.bkcode}`,
    params.request
  );
}

export interface DeleteParbankParams {
  bkcode?: string;
}

/**
 * @tags Parbank Controller
 * @summary deleteParbank
 */
export function deleteParbank(params: DeleteParbankParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parbank/${params.bkcode}`
  );
}

export interface Parbankbranch {
  bkbranchid: number;
  bkbranchaddress: string;
  bkbranchcode: string;
  bkbranchname: string;
  bkcode?: string;
}

export interface GetParbankbranchBycriteriaParams {
  bkbranchaddress: string;
  bkbranchcode: string;
  bkbranchname: string;
  bkcode?: string;
}

/**
 * @tags Parbank Controller
 * @summary getParbankbranchBycriteria
 */
export function getParbankbranchBycriteria(
  params: GetParbankbranchBycriteriaParams
) {
  return request.get<AbstractResponse<object, Parbankbranch>>(
    `${URL}/api/parbank/branch` +
    prepareQueryParams({
      bkbranchaddress: params.bkbranchaddress,
      bkbranchcode: params.bkbranchcode,
      bkbranchname: params.bkbranchname,
      bkcode: params.bkcode,
    } as any)
  );
}

export interface AddParbankbranchParams {
  request: Parbankbranch;
}

/**
 * @tags Parbank Controller
 * @summary addParbankbranch
 */
export function addParbankbranch(params: AddParbankbranchParams) {
  return request.post<AbstractResponse<Parbankbranch, object>>(
    `${URL}/api/parbank/branch`,
    params.request
  );
}

export interface UpdateParbankbranchParams {
  bkbranchid: Number;
  request: Parbankbranch;
}

/**
 * @tags Parbank Controller
 * @summary updateParbankbranch
 */
export function updateParbankbranch(params: UpdateParbankbranchParams) {
  return request.put<AbstractResponse<Parbankbranch, object>>(
    `${URL}/api/parbank/branch/${params.bkbranchid}`,
    params.request
  );
}

export interface DeleteParbankbranchParams {
  bkbranchid: Number;
}

/**
 * @tags Parbank Controller
 * @summary deleteParbankbranch
 */
export function deleteParbankbranch(params: DeleteParbankbranchParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parbank/branch/${params.bkbranchid}`
  );
}

export interface GetParcolunpaidlevelsBycriteriaParams {
  collevel: string;
  mgid: number;
  nbdaysmax: number;
  nbdaysmin: number;
  criteriatype: string;
}

/**
 * @tags Parcolunpaidlevels Controller
 * @summary getParcolunpaidlevelsBycriteria
 */
export function getParcolunpaidlevelsBycriteria(
  params: GetParcolunpaidlevelsBycriteriaParams
) {
  return request.get<AbstractResponse<object, Parcolunpaidlevels>>(
    `${URL}/api/parcolunpaidlevels` +
    prepareQueryParams({
      collevel: params.collevel,
      mgid: params.mgid,
      nbdaysmax: params.nbdaysmax,
      nbdaysmin: params.nbdaysmin,
      criteriatype: params.criteriatype,
    } as any)
  );
}

export interface AddparcolunpaidlevelsParams {
  request: Parcolunpaidlevels;
}

/**
 * @tags Parcolunpaidlevels Controller
 * @summary addparcolunpaidlevels
 */
export function addparcolunpaidlevels(params: AddparcolunpaidlevelsParams) {
  return request.post<AbstractResponse<Parcolunpaidlevels, object>>(
    `${URL}/api/parcolunpaidlevels`,
    params.request
  );
}

export interface UpdateParcolunpaidlevelsParams {
  parcollevelid: number;
  request: Parcolunpaidlevels;
}

/**
 * @tags Parcolunpaidlevels Controller
 * @summary UpdateParcolmanagers
 */
export function UpdateParcolunpaidlevels(
  params: UpdateParcolunpaidlevelsParams
) {
  return request.put<AbstractResponse<Parcolunpaidlevels, object>>(
    `${URL}/api/parcolunpaidlevels/${params.parcollevelid}`,
    params.request
  );
}

export interface RemoveparcolunpaidlevelsParams {
  parcollevelid: number;
}

/**
 * @tags Parcolunpaidlevels Controller
 * @summary removeparcolunpaidlevels
 */
export function removeparcolunpaidlevels(
  params: RemoveparcolunpaidlevelsParams
) {
  return request.delete<AbstractResponse<Parcolunpaidlevels, object>>(
    `${URL}/api/parcolunpaidlevels/${params.parcollevelid}`
  );
}

export interface Parcolmanagers {
  applicationrule: string;
  enddate: string;
  managerroleprofile: string;
  managertype: string;
  mgid: number;
  parcolmanagersid: number;
  startdate: string;
  status: string;
  taskidnotif: number;
  userid: number;
  proccode?: string;
}

export interface GetParcolmanagersBycriteriaParams {
  managerroleprofile: string;
  managertype: string;
  mgid: number;
  status: string;
  userid: number;
}

/**
 * @tags Parcolmanagers Controller
 * @summary getParcolmanagersBycriteria
 */
export function getParcolmanagersBycriteria(
  params: GetParcolmanagersBycriteriaParams
) {
  return request.get<AbstractResponse<object, Parcolmanagers>>(
    `${URL}/api/parcolmanagers` +
    prepareQueryParams({
      managerroleprofile: params.managerroleprofile,
      managertype: params.managertype,
      mgid: params.mgid,
      status: params.status,
      userid: params.userid,
    } as any)
  );
}

export interface AddParcolmanagersParams {
  request: Parcolmanagers;
}

/**
 * @tags Parcolmanagers Controller
 * @summary addParcolmanagers
 */
export function addParcolmanagers(params: AddParcolmanagersParams) {
  return request.post<AbstractResponse<Parcolmanagers, object>>(
    `${URL}/api/parcolmanagers`,
    params.request
  );
}

export interface UpdateParcolmanagersParams {
  parcolmanagersid: number;
  request: Parcolmanagers;
}

/**
 * @tags Parcolmanagers Controller
 * @summary UpdateParcolmanagers
 */
export function UpdateParcolmanagers(params: UpdateParcolmanagersParams) {
  return request.put<AbstractResponse<Parcolmanagers, object>>(
    `${URL}/api/parcolmanagers/${params.parcolmanagersid}`,
    params.request
  );
}

export interface RemoveParcolmanagersParams {
  parcolmanagersid: number;
}

/**
 * @tags Parcolmanagers Controller
 * @summary removeParcolmanagers
 */
export function removeParcolmanagers(params: RemoveParcolmanagersParams) {
  return request.delete<AbstractResponse<Parcolmanagers, object>>(
    `${URL}/api/parcolmanagers/${params.parcolmanagersid}`
  );
}

export interface UpdateParcolmanagersStatusParams {
  parcolmanagersid: number;
  status: string;
}

/**
 * @tags Parcolmanagers Controller
 * @summary UpdateParcolmanagersStatus
 */
export function UpdateParcolmanagersStatus(
  params: UpdateParcolmanagersStatusParams
) {
  return request.put<AbstractResponse<Parcolmanagers, object>>(
    `${URL}/api/parcolmanagers/${params.parcolmanagersid}/${params.status}`
  );
}

export interface GetUsersListByDepartmentParams {
  parentValue: string;
}

/**
 * @tags Users Controller
 * @summary getUsersByParentValue
 */
export function getUsersListByDepartment(
  params: GetUsersListByDepartmentParams
) {
  return request.get<AbstractResponse<object, MgBUserProfileResponse>>(
    `${URL}/api/usersList/department/${params.parentValue}`
  );
}
export interface DuplicateUserParams {
  email: string;
  name: string;
  surname: string;
  userid: number;
  mobile: string;
  phone: string;
}

export interface UserResponse {
  name: string;
  userid: number;
}

export function getMyAuthorizedUsersList() {
  return request.get<AbstractResponse<object, UserResponse>>(
    `${URL}/api/myAuthorizedUsersList`
  );
}
/**
 * @tags Users Controller
 * @summary DuplicateUser
 */
export function DuplicateUser(params: DuplicateUserParams) {
  return request.post<AbstractResponse<Users, object>>(
    `${URL}/api/users/duplicate/${params.userid}` +
    prepareQueryParams({
      email: params.email,
      name: params.name,
      surname: params.surname,
      mobile: params.mobile,
      phone: params.phone,
    } as any)
  );
}

export interface UserKeywords {
  color: string;
  fontsize: number;
  keyword: string;
  kwid: number;
  kworder: number;
  userid: number;
}

/**
 * @tags Users Controller
 * @summary getMyKeywords
 */
export function getMyKeywords() {
  return request.get<AbstractResponse<object, UserKeywords>>(
    `${URL}/api/users/myKeywords`
  );
}

export interface AddKeywordParams {
  request: UserKeywords;
}

/**
 * @tags Users Controller
 * @summary addKeyword
 */
export function addKeyword(params: AddKeywordParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/users/myKeywords`,
    params.request
  );
}

export interface RemoveKeywordParams {
  kwid: number;
}

/**
 * @tags Users Controller
 * @summary removeKeyword
 */
export function removeKeyword(params: RemoveKeywordParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/users/myKeywords/${params.kwid}`
  );
}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface MgBrokerParFilteringResponse {
  filterid: number;
  flagdefault: boolean;
  mgid: number;
  mgname: string;
  parcode: string;
  parcodelabel: string;
  parvalue: string;
  parvaluelabel: string;
  tpidbroker: number;
}

export interface MgBrokerParFilteringRequest {
  filterid: number;
  flagdefault: boolean;
  mgid: number;
  parcode: string;
  parvalue: string;
  tpidbroker: number;
}

export interface ImportParListFileParams {
  filename: string;
}

/**
 * @tags Par List Controller
 * @summary importParListFile
 */
export function importParListFile(params: ImportParListFileParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/importParListFile` +
    prepareQueryParams({ filename: params.filename } as any)
  );
}

/**
 * @tags Par List Controller
 * @summary getFiles
 */
export function getFiles() {
  return request.get<AbstractResponse<object, string>>(`${URL}/api/files`);
}

export interface GetMyBrokerParValuesParams {
  parcode: string;
}

/**
 * @tags Users Controller
 * @summary getMyBrokerParValues
 */
export function getMyBrokerParValues(params: GetMyBrokerParValuesParams) {
  return request.get<AbstractResponse<object, MgBrokerParFilteringResponse>>(
    `${URL}/api/broker/myParfilering` +
    prepareQueryParams({ parcode: params.parcode } as any)
  );
}

export interface GetParValuesByBrokerParams {
  mgid: number;
  parcode: string;
  tpidbroker: number;
}

/**
 * @tags Users Controller
 * @summary getParValuesByBroker
 */
export function getParValuesByBroker(params: GetParValuesByBrokerParams) {
  return request.get<AbstractResponse<object, MgBrokerParFilteringResponse>>(
    `${URL}/api/broker/parfilering` +
    prepareQueryParams({
      mgid: params.mgid,
      parcode: params.parcode,
      tpidbroker: params.tpidbroker,
    } as any)
  );
}

export interface GetParFilteringByBrokerParams {
  tpidbroker: number;
}

/**
 * @tags Users Controller
 * @summary getParFilteringByBroker
 */
export function getParFilteringByBroker(params: GetParFilteringByBrokerParams) {
  return request.get<AbstractResponse<object, MgBrokerParFilteringResponse>>(
    `${URL}/api/broker/${params.tpidbroker}/parfilering`
  );
}

export interface CreateBrokerParFilteringParams {
  request: MgBrokerParFilteringRequest;
  tpidbroker: number;
}

/**
 * @tags Users Controller
 * @summary createBrokerParFiltering
 */
export function createBrokerParFiltering(
  params: CreateBrokerParFilteringParams
) {
  return request.post<AbstractResponse<MgBrokerParFilteringResponse, object>>(
    `${URL}/api/broker/${params.tpidbroker}/parfilering`,
    params.request
  );
}

export interface RemoveBrokerParFilteringParams {
  filterid: number;
  tpidbroker: number;
}

/**
 * @tags Users Controller
 * @summary removeBrokerParFiltering
 */
export function removeBrokerParFiltering(
  params: RemoveBrokerParFilteringParams
) {
  return request.delete<AbstractResponse<object, MgBrokerParFilteringResponse>>(
    `${URL}/api/broker/${params.tpidbroker}/parfilering/${params.filterid}`
  );
}

export interface ParCalendarResponse {
  calid: number;
  callabel: string;
  countcode: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export function getParCalendarList() {
  return request.get<AbstractResponse<ParCalendarResponse, object>>(
    `${URL}/api/parcalendar`
  );
}

export interface ParCalendarRequest {
  calid: number;
  callabel: string;
  countcode: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export interface AddParCalendarParams {
  request: ParCalendarRequest;
}

/**
 * @tags Parametes Controller
 * @summary addParCalendar
 */
export function addParCalendar(params: AddParCalendarParams) {
  return request.post<AbstractResponse<ParCalendarResponse, object>>(
    `${URL}/api/parcalendar`,
    params.request
  );
}

export interface ParCalendarParams {
  request: ParCalendarRequest;
  calid: number;
}

/**
 * @tags Parametes Controller
 * @summary updateParCalendar
 */
export function updateParCalendar(params: ParCalendarParams) {
  return request.put<AbstractResponse<ParCalendarResponse, object>>(
    `${URL}/api/parcalendar/${params.calid}`,
    params.request
  );
}

export interface RemoveParCalendarParams {
  calid: number;
}

/**
 * @tags Parametes Controller
 * @summary deleteParCalendar
 */
export function removeParCalendar(params: RemoveParCalendarParams) {
  return request.delete<AbstractResponse<object, ParCalendarResponse>>(
    `${URL}/api/parcalendar/${params.calid}`
  );
}

export interface ParCalendarHolidaysResponse {
  calid: number;
  cholid: number;
  year: number;
  holidaydate: string;
  holidaytype: string;
  holidaylabel: string;
}

export interface GetParCalendarHolidaysListParams {
  calid: number;
  year: number;
}

export function getParCalendarHolidaysList(
  params: GetParCalendarHolidaysListParams
) {
  return request.get<AbstractResponse<ParCalendarHolidaysResponse, object>>(
    `${URL}/api/parcalendarholidays` +
    prepareQueryParams({
      calid: params.calid,
      year: params.year
    } as any)
  );
}

export interface ParCalendarHolidaysRequest {
  calid: number;
  cholid: number;
  year: number;
  holidaydate: string;
  holidaytype: string;
  holidaylabel: string;
}

export interface AddParCalendarHolidaysParams {
  request: ParCalendarHolidaysRequest;
}

/**
 * @tags Parametes Controller
 * @summary addParCalendar
 */
export function addParCalendarHolidays(params: AddParCalendarHolidaysParams) {
  return request.post<AbstractResponse<ParCalendarHolidaysResponse, object>>(
    `${URL}/api/parcalendarholidays`,
    params.request
  );
}

export interface DuplicateParCalendarHolidaysParams {
  calid: number;
}

/**
 * @tags Parametes Controller
 * @summary addParCalendar
 */
export function duplicateParCalendarHolidays(params: DuplicateParCalendarHolidaysParams) {
  return request.post<AbstractResponse<object, ParCalendarHolidaysResponse>>(
    `${URL}/api/parcalendarholidays/duplicate/${params.calid}`
  );
}

export interface ParCalendarHolidaysParams {
  request: ParCalendarHolidaysRequest;
  cholid: number;
}

/**
 * @tags Parametes Controller
 * @summary updateParCalendar
 */
export function updateParCalendarHolidays(params: ParCalendarHolidaysParams) {
  return request.put<AbstractResponse<ParCalendarHolidaysResponse, object>>(
    `${URL}/api/parcalendarholidays/${params.cholid}`,
    params.request
  );
}

export interface RemoveParCalendarHolidaysParams {
  cholid: number;
}

/**
 * @tags Parametes Controller
 * @summary deleteParCalendar
 */
export function removeParCalendarHolidays(
  params: RemoveParCalendarHolidaysParams
) {
  return request.delete<AbstractResponse<object, ParCalendarHolidaysResponse>>(
    `${URL}/api/parcalendarholidays/${params.cholid}`
  );
}
/**
 * @tags Product Conversion Rule Controller
 * @summary get all conversion rules
 */
export function getAllConversionRules() {
  return request.get<AbstractResponse<object, ProductConversionRuleResponse>>(
    `${URL}/api/conversionrule/list`
  );
}

/**
 * @tags Product Conversion Rule Controller
 * @summary get rule by id
 */
export function getConversionRuleById(id: number) {
  return request.get<AbstractResponse<object, ProductConversionRuleResponse>>(
    `${URL}/api/conversionrule/${id}`
  );
}

export interface CreateConversionRuleParams {
  request: ProductConversionRuleRequest;
}

/**
 * @tags Product Conversion Rule Controller
 * @summary create a new conversion rule
 */
export function createConversionRule(params: CreateConversionRuleParams) {
  return request.post<AbstractResponse<ProductConversionRuleResponse, object>>(
    `${URL}/api/conversionrule`,
    params.request
  );
}

export interface UpdateConversionRuleParams {
  id: number;
  request: ProductConversionRuleRequest;
}

/**
 * @tags Product Conversion Rule Controller
 * @summary update an existing conversion rule
 */
export function updateConversionRule(params: UpdateConversionRuleParams) {
  return request.put<AbstractResponse<ProductConversionRuleResponse, object>>(
    `${URL}/api/conversionrule/${params.id}`,
    params.request
  );
}

export interface DeleteConversionRuleParams {
  id: number;
}

/**
 * @tags Product Conversion Rule Controller
 * @summary delete a conversion rule by id
 */
export function deleteConversionRule(params: DeleteConversionRuleParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/conversionrule/${params.id}`
  );
}

export interface GetConversionRulesBySourceParams {
  sourcePrcode: string;
}

/**
 * @tags Product Conversion Rule Controller
 * @summary get rules by source prcode
 */
export function getConversionRulesBySource(params: GetConversionRulesBySourceParams) {
  return request.get<AbstractResponse<object, ProductConversionRuleResponse>>(
    `${URL}/api/conversionrule/source/${params.sourcePrcode}`
  );
}

export interface CheckConversionAllowedParams {
  sourcePrcode: string;
  targetPrcode: string;
}

/**
 * @tags Product Conversion Rule Controller
 * @summary check if conversion is allowed between source and target
 */
export function checkConversionAllowed(params: CheckConversionAllowedParams) {
  return request.get<AbstractResponse<object, boolean>>(
    `${URL}/api/conversionrule/isallowed` +
    prepareQueryParams(params as any)
  );
}

/**
 * @tags Product Conversion Rule Controller
 * @summary get all available source prcodes
 */
export function getAllSourcePrcodes() {
  return request.get<AbstractResponse<object, string>>(
    `${URL}/api/conversionrule/sourceprcodes`
  );
}

export interface GetTargetPrcodesParams {
  sourcePrcode: string;
}

/**
 * @tags Product Conversion Rule Controller
 * @summary get all target prcodes available for a source
 */
export function getAvailableTargetPrcodes(params: GetTargetPrcodesParams) {
  return request.get<AbstractResponse<object, string>>(
    `${URL}/api/conversionrule/targetprcodes/${params.sourcePrcode}`
  );
}
export type GetProductConversionRuleCriteriaParams = {
  sourcePrcode?: string;
  targetPrcode?: string;
  isAuthorized?: boolean;
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: string;
};

export function getConversionRuleListByCriteria(params: GetProductConversionRuleCriteriaParams) {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    const shouldInclude =
      typeof value === 'boolean' || (value !== undefined && value !== null && value !== '');

    if (shouldInclude) {
      queryParams.append(key, String(value));
    }
  });

  const queryString = queryParams.toString();
  const finalUrl = `${URL}/api/conversionrule/productconversionrules${queryString ? '?' + queryString : ''}`;

  return request.get<AbstractResponse<object, ProductConversionRuleResponse>>(finalUrl);
}



// Interfaces
export interface ProductConversionRuleRequest {
  sourcePrcode: string;
  targetPrcode: string;
  isAuthorized: boolean;
}

export interface ProductConversionRuleResponse {
  rulid: number;
  sourcePrcode: string;
  sourcePrcodelabel?: string;
  targetPrcode: string;
  targetPrcodelabel?:string;
  isAuthorized: boolean;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
}

export async function importBonification(file: File): Promise<any> {
  const formData = new FormData();
  formData.append('file', file);

  const token = localStorage.getItem('token'); 

  try {
    const response = await fetch(`${URL}/api/bonification/import`, {
      method: 'POST',
      headers: {
        
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Import error:', error);
    throw error;
  }
}
export interface AbstractResponse<D, L> {
  code: string
  message: string
  data: D
  list: L[]
}

export interface GetLatestBonificationParams {
  thirdpartyId: number
  activity: string
}

export interface BonificationResponse {
  id: number
  nomSTM: string | null
  nomTM: string | null
  rrdi: string | null
  activity: string
  taux: number
  dateDebut: string
  dateFin: string
  thirdpartyId: number
}


export function getLatestBonification(params: GetLatestBonificationParams) {
  return request.get<AbstractResponse<BonificationResponse, object>>(
    `${URL}/api/bonification/latest?thirdpartyId=${params.thirdpartyId}&activity=${params.activity}`,
  )
}
export interface JobSummary {
  totalJobs: number;
  completedJobs: number;
  runningJobs: number;
  errorJobs: number;
  totalLinesProcessed: number;
  totalLinesValidated: number;
  totalLinesRejected: number;
}

export interface BonificationReportDto {
  jobId: number;
  fileName: string;
  status: string;
  startTime: string;
  endTime: string;
  totalLines: number;
  processed: number;
  validated: number;
  rejected: number;
  errors: number;
  user: string;
  logFile: string;
  rejectFile: string;
  errorMessage: string;
  duration: string;
}

export interface RejectionDetail {
  id: number;
  jobId: number;
  lineNumber: number;
  rejectionReason: string;
  lineContent: string;
  rejectedAt: string;
}


export interface GetBonificationReportsParams {
  status?: string; // 'COMPLETED' | 'RUNNING' | 'ERROR' | 'all'
}

export const bonificationApi = {
  // Get all bonification reports with optional status filter
  getBonificationReports(params?: GetBonificationReportsParams) {
    const queryParams = params?.status ? `?status=${params.status}` : '';
    return request.get<AbstractResponse< object,BonificationReportDto[]>>(
      `${URL}/api/bonification/reports${queryParams}`
    );
  },

  // Get specific bonification report by ID
  getBonificationReport(jobId: number) {
    return request.get<AbstractResponse<object,BonificationReportDto>>(
      `${URL}/api/bonification/reports/${jobId}`
    );
  },

  // Get bonification summary statistics
  getBonificationSummary() {
    return request.get<AbstractResponse<object,JobSummary>>(
      `${URL}/api/bonification/summary`
    );
  },

  // Get rejection details for a specific job
  getRejectionDetails(jobId: number) {
    return request.get<AbstractResponse<object,RejectionDetail[]>>(
      `${URL}/api/bonification/reports/${jobId}/rejections`
    );
  },

  // Health check endpoint
  healthCheck() {
    return request.get<AbstractResponse<object,string>>(
      `${URL}/api/bonification/health`
    );
  },

  // Download log file for a job
  async downloadLogFile(jobId: number): Promise<Blob> {
    const token = localStorage.getItem('token');
    const headers = new Headers();
    if (token) {
      headers.append('Authorization', `Bearer ${token}`);
    }
    const response = await fetch(`${URL}/api/bonification/reports/${jobId}/download-log`, {
      method: 'GET',
      headers,
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to download log file: ${response.status} ${errorText}`);
    }
    return response.blob();
  },

  // Download reject file for a job
  async downloadRejectFile(jobId: number): Promise<Blob> {
    const token = localStorage.getItem('token');
    const headers = new Headers();
    if (token) {
      headers.append('Authorization', `Bearer ${token}`);
    }
    const response = await fetch(`${URL}/api/bonification/reports/${jobId}/download-reject`, {
      method: 'GET',
      headers,
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to download reject file: ${response.status} ${errorText}`);
    }
    return response.blob();
  },
};

// Alternative individual functions (if you prefer this style)
export function getBonificationReports(params?: GetBonificationReportsParams) {
  const queryParams = params?.status ? `?status=${params.status}` : '';
  return request.get<AbstractResponse<object,BonificationReportDto[]>>(
    `${URL}/api/bonification/reports${queryParams}`
  );
}

export function getBonificationReport(jobId: number) {
  return request.get<AbstractResponse<object,BonificationReportDto>>(
    `${URL}/api/bonification/reports/${jobId}`
  );
}

export function getBonificationSummary() {
  return request.get<AbstractResponse<object,JobSummary>>(
    `${URL}/api/bonification/summary`
  );
}

export function getRejectionDetails(jobId: number) {
  return request.get<AbstractResponse<object,RejectionDetail[]>>(
    `${URL}/api/bonification/reports/${jobId}/rejections`
  );
}

export function healthCheck() {
  return request.get<AbstractResponse<object,string>>(
    `${URL}/api/bonification/health`
  );
}

export function getConversionRulesBySourcePrcode(sourcePrcode: string){
  return request.get<AbstractResponse<object, ProductConversionRuleResponse>>(
    `${URL}/api/conversionrule/source/${sourcePrcode}`
  );
}

export async function downloadLogFile(jobId: number): Promise<Blob> {
  const token = localStorage.getItem('token');
  const headers = new Headers();
  if (token) {
    headers.append('Authorization', `Bearer ${token}`);
  }
  const response = await fetch(`${URL}/api/bonification/reports/${jobId}/download-log`, {
    method: 'GET',
    headers,
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Failed to download log file: ${response.status} ${errorText}`);
  }
  return response.blob();
}

export async function downloadRejectFile(jobId: number): Promise<Blob> {
  const token = localStorage.getItem('token');
  const headers = new Headers();
  if (token) {
    headers.append('Authorization', `Bearer ${token}`);
  }
  const response = await fetch(`${URL}/api/bonification/reports/${jobId}/download-reject`, {
    method: 'GET',
    headers,
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Failed to download reject file: ${response.status} ${errorText}`);
  }
  return response.blob();
}


// Utility functions to handle AbstractResponse
export function extractData<T>(response: AbstractResponse<any, T>): T[] {
  if (response.code !== '200') {
    throw new Error(response.message || 'Request failed');
  }
  return response.list;
}

export function isSuccessResponse(response: AbstractResponse<any, any>): boolean {
  return response.code === '200';
}